"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ROLES: function() {
        return ROLES;
    },
    collection: function() {
        return collection;
    },
    default: function() {
        return _default;
    },
    sd: function() {
        return sd;
    }
});
const sd = {
    "brandIds": [
        "smackdown"
    ]
};
const ROLES = {
    FIGHTER: "FIGHTER",
    BRUISER: "BRUISER",
    CRUISER: "CRUISER",
    SPECIALIST: "SPECIALIST",
    GIANT: "GIANT"
};
const collection = [
    {
        "id": "roman-reigns",
        "name": "Roman Reigns",
        "nickname": "The Tribal Chief",
        "role": ROLES.BRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/04/Roman_PROFILE--a693aaf95d89f652dd64e3f5deb115e9.png",
        "points": 98,
        "cost": 100000,
        "alignment": "BAD",
        ...sd,
        "popularity": 100,
        "charisma": 100,
        "stamina": 100,
        "morale": 100,
        "wins": 795,
        "losses": 323,
        "streak": 40,
        "followers": 4900000,
        "entranceVideoEmbedId": "ql23nGzD8GE",
        "dob": "May 25, 1985"
    },
    {
        "id": "john-cena",
        "name": "John Cena",
        "nickname": "The Champ",
        "role": ROLES.FIGHTER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/John_Cena_PROFILE--7e93cef8e1149433838904bf719fa74e.png",
        "points": 85,
        "cost": 99000,
        "alignment": "GOOD",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 90,
        "charisma": 85,
        "stamina": 50,
        "morale": 100,
        "followers": 5000,
        "dob": "April 23, 1977"
    },
    {
        "id": "stone-cold-steve-austin",
        "name": "Steve Austin",
        "nickname": "Stone Cold",
        "role": ROLES.BRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Stone_Cold_Steve_Austin_pro.png",
        "points": 99,
        "cost": 500000,
        "alignment": "GOOD",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 100,
        "charisma": 100,
        "stamina": 100,
        "morale": 100,
        "followers": 500000
    },
    {
        "id": "the-rock",
        "name": "The Rock",
        "nickname": "The Great One",
        "brandIds": [
            "hall-of-fame"
        ],
        "role": ROLES.BRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Dwayne_The_Rock_Johnson_pro.png",
        "points": 100,
        "cost": 100000,
        "alignment": "BAD",
        "popularity": 100,
        "charisma": 100,
        "stamina": 100,
        "morale": 100,
        "followers": 5000000
    },
    {
        "id": "drew-mcintyre",
        "name": "Drew McIntyre",
        "nickname": "The Scottish Warrior",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/09/Drew_Mcintyre_Profile--aca391095fe74e721e098cadc93571d3.png",
        "points": 89,
        "goalIds": [
            "world-heavyweight"
        ],
        "role": ROLES.BRUISER,
        "cost": 85000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 80,
        "morale": 60,
        "followers": 5000,
        "wins": 593,
        "losses": 611,
        "streak": 7,
        "entranceVideoEmbedId": "47cmwx8qZAk"
    },
    {
        "id": "randy-orton",
        "name": "Randy Orton",
        "nickname": "The Viper",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/03/Randy_Orton_11272023rf_071_Profile--9f48e983c9e721c0a5659fc639f1c14a.png",
        "points": 90,
        "role": ROLES.SPECIALIST,
        "cost": 85000,
        ...sd,
        "alignment": "GOOD",
        "popularity": 90,
        "charisma": 90,
        "stamina": 60,
        "morale": 80,
        "followers": 500000,
        "damage": 30,
        "active": true
    },
    {
        "id": "randy-orton-retro",
        "name": "Randy Orton Retro",
        "nickname": "The Viper",
        "role": ROLES.SPECIALIST,
        "image": "//www.wwe.com/f/styles/gallery_img_l/public/all/2020/07/004_Orto_10082007rf_054b--3035f42e9993d1988bded5655bf22d3c.jpg",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "entranceVideoEmbedId": "H5enKjKAlQU"
    },
    {
        "id": "aj-styles",
        "name": "AJ Styles",
        "nickname": "The Phenomenal One",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/03/AJ_PROFILE--3dba1444cd562cc643b680cb5fdb2465.png",
        ...sd,
        "goalIds": [
            "wwe-title"
        ],
        "role": ROLES.SPECIALIST,
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "popularity": 100,
        "charisma": 100,
        "stamina": 100,
        "morale": 100,
        "followers": 500000,
        "entranceVideoEmbedId": "fj9ala8nZ7U"
    },
    {
        "id": "bobby-lashley",
        "name": "Bobby Lashley",
        "nickname": "The All Mighty",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/10/Bobby_Lashley_PROFILE--13359ab20042eb81aafab6c8ed280183.png",
        "points": 89,
        "cost": 60000,
        "alignment": "GOOD",
        ...sd,
        "popularity": 70,
        "charisma": 70,
        "role": ROLES.FIGHTER,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "undertaker",
        "name": "Undertaker",
        "nickname": "The Deadman",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Undertaker_Pro--e73c07b669f8d823088cf8de4cebfde8.png",
        "points": 99,
        "cost": 100000,
        "role": ROLES.BRUISER,
        "alignment": "GOOD",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 90,
        "charisma": 85,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "kane",
        "name": "Kane",
        "role": ROLES.GIANT,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2020/01/Kane_Pro--97fd51c6219810ef02070c332958e10a.png",
        "nickname": "The Big Red Machine",
        "points": 89,
        "cost": 100000,
        "alignment": "bad",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 90,
        "charisma": 85,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "bronson-reed",
        "name": "Bronson Reed",
        "nickname": "Big",
        "role": ROLES.GIANT,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2023/01/Bronson_Reed_PROFILE--0ff0270b2431f0938140d6dbaf76f203.png",
        "points": 84,
        "cost": 100000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "ic"
        ],
        "popularity": 50,
        "charisma": 75,
        "stamina": 50,
        "morale": 580,
        "followers": 50000
    },
    {
        "id": "asuka",
        "name": "Asuka",
        "nickname": "The Empress of Tomorrow",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/02/Asuka_PROFILE--020df70e71e4c3706e8b87d423893dd3.png",
        "gender": "FEMALE",
        "points": 90,
        "cost": 65000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "sasha-banks",
        "name": "Sasha Banks",
        "nickname": "The Boss",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/09/Sasha_Banks_Pro--6e2411e37d7224354f475d15d3e47fb0.png",
        "gender": "FEMALE",
        "points": 0,
        "cost": 65000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "active": false
    },
    {
        "id": "mercedes-martinez",
        "name": "Mercedes Martinez",
        "gender": "FEMALE",
        "role": ROLES.SPECIALIST,
        "points": 80,
        "cost": 40000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "becky-lynch",
        "name": "Becky Lynch",
        "nickname": "The man",
        "role": ROLES.SPECIALIST,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/03/Becky_Lynch_PROFILE--0a8b02ec3d3e203b817d3b7674bd0a9e.png",
        "gender": "FEMALE",
        "points": 95,
        "cost": 70000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "popularity": 95,
        "charisma": 75,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "entranceVideoEmbedId": "xjS0uLKuhBo"
    },
    {
        "id": "charlotte-flair",
        "name": "Charlotte Flair",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/CharlotteFlair_01122023PB_0365_Profile--7190563facbfe218729ea64a62b877f8.png",
        "gender": "FEMALE",
        "points": 92,
        "cost": 70000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000,
        "damage": 80,
        "active": false,
        "entranceVideoEmbedId": "9j7vE0x46iA"
    },
    {
        "id": "logan-paul",
        "name": "Logan Paul",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Logan_Paul_PROFILE--479a7c8503950ea02f1b6f2819b79f81.png",
        "points": 90,
        "cost": 75000,
        "alignment": "BAD",
        ...sd,
        "popularity": 90,
        "charisma": 80,
        "stamina": 70,
        "morale": 100,
        "followers": 500000
    },
    {
        "id": "bayley",
        "name": "Bayley",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/10/Bayley_PROFILE--273098f523f8aa4826af096150e1d15e.png",
        "gender": "FEMALE",
        "points": 85,
        "cost": 60000,
        "alignment": "GOOD",
        "role": ROLES.SPECIALIST,
        "brandIds": [
            "smackdown"
        ],
        "popularity": 85,
        "charisma": 75,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "ronda-rousey",
        "name": "Ronda Rousey",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/10/Ronda_Rousey_PROFILE--7486dd70f49ff6675221514613d761c6.png",
        "gender": "FEMALE",
        "role": ROLES.FIGHTER,
        "points": 70,
        "cost": 700000,
        "alignment": "BAD",
        "popularity": 85,
        "charisma": 55,
        "stamina": 50,
        "brandIds": [
            "roh",
            "smackdown"
        ],
        "morale": 20,
        "followers": 500000,
        "damage": 20,
        "active": true,
        "dob": "1987-02-01"
    },
    {
        "id": "adamcole",
        "name": "Adam Cole",
        "nickname": "The Devil",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "popularity": 75,
        "charisma": 85,
        "stamina": 30,
        "damage": 80,
        "morale": 40,
        "followers": 50000,
        "active": false,
        "image": "//static.wixstatic.com/media/815952_601871010e0243ebab33a02782dff556~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_601871010e0243ebab33a02782dff556~mv2.jpg"
    },
    {
        "id": "abadon",
        "name": "Abadon",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "damage": 60,
        "image": "//static.wixstatic.com/media/815952_2c0f98019f954dc7a6d966566650b99b~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_2c0f98019f954dc7a6d966566650b99b~mv2.jpg"
    },
    {
        "id": "max-caster",
        "name": "Max Caster",
        "image": "//static.wixstatic.com/media/815952_ca2c775b110340cf84388c47cc045a4a~mv2.jpg/v1/fill/w_380,h_380,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_ca2c775b110340cf84388c47cc045a4a~mv2.jpg",
        "points": 80,
        "cost": 20000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 90,
        "charisma": 70,
        "stamina": 50,
        "morale": 50,
        "followers": 100000
    },
    {
        "id": "anthony-bowens",
        "name": "Anthony Bowens",
        "image": "//static.wixstatic.com/media/815952_47f39dcba25843279a4762ba81cb18b5~mv2.jpg/v1/fill/w_380,h_380,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_47f39dcba25843279a4762ba81cb18b5~mv2.jpg",
        "points": 90,
        "cost": 20000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 50,
        "morale": 50,
        "followers": 50000
    },
    {
        "id": "chrisjericho",
        "name": "Chris Jericho",
        "image": "//static.wixstatic.com/media/ac2041_4c81455fcb6b45589b3b5568a65bbcad~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_4c81455fcb6b45589b3b5568a65bbcad~mv2.jpg",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "WHU5D2O31vs",
        "dob": "1970-11-09"
    },
    {
        "id": "seth-rollins",
        "name": "Seth Rollins",
        "nickname": "The Architect",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/04/Seth-Rollins_01282024RF_04450_Profile--a5d406bf9b4431355cb37805c9c9ebbe.png",
        "points": 93,
        "cost": 75000,
        "alignment": "GOOD",
        "role": ROLES.FIGHTER,
        "brandIds": [
            "raw"
        ],
        "popularity": 80,
        "charisma": 90,
        "stamina": 50,
        "morale": 90,
        "followers": 5000,
        "entranceVideoEmbedId": "U6g10Gvu3gw",
        "dob": "1986-05-28"
    },
    {
        "id": "finn-balor",
        "name": "Finn B\xe1lor",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/FInn_Balor_PROFILE--ea6510cd60d74daf7bdf27b6ea93573d.png",
        "points": 87,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 60,
        "followers": 5000,
        "dob": "1981-08-25"
    },
    {
        "id": "cody-rhodes",
        "name": "Cody Rhodes",
        "nickname": "The American Nightmare",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/04/CODY_RHODES_Profile--c362b89cfb048a40f775cd6f5a237cde.png",
        "points": 94,
        "cost": 70000,
        "alignment": "GOOD",
        "role": ROLES.FIGHTER,
        "brandIds": [
            "raw",
            "smackdown"
        ],
        "popularity": 96,
        "charisma": 90,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "wins": 786,
        "losses": 753,
        "streak": 12,
        "entranceVideoEmbedId": "6Gr5vZ-bmSI",
        "dob": "1985-04-30"
    },
    {
        "id": "riddle",
        "name": "Riddle",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/RIDDLE_04032023sb0071_profile--9ed1e65f118618d7f26bdfe0fc357c7b.png",
        "points": 75,
        "cost": 55000,
        "role": ROLES.FIGHTER,
        "alignment": "GOOD",
        "followers": 5000,
        "entranceVideoEmbedId": "bbSv8xvJtNg",
        "dob": "1985-04-30"
    },
    {
        "id": "shayna-baszler",
        "name": "Shayna Baszler",
        "role": ROLES.FIGHTER,
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/03/Shayna_Baszler_Profile--3c1a3d7f5b91116d64f80c02ebd83755.png",
        "gender": "FEMALE",
        "points": 82,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "popularity": 70,
        "charisma": 30,
        "stamina": 80,
        "morale": 75,
        "followers": 50000
    },
    {
        "id": "jamie-hayter",
        "name": "Jamie Hayter",
        "image": "//static.wixstatic.com/media/ac2041_871f5dcacb61492a878baed5fe9cd322~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_871f5dcacb61492a878baed5fe9cd322~mv2.jpg",
        "gender": "FEMALE",
        "points": 90,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "kevin-owens",
        "name": "Kevin Owens",
        "role": ROLES.FIGHTER,
        "nickname": "KO",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/09/Kevin_OWens_PROFILE--05fe489008b716e22e4d0abeba8b4939.png",
        "points": 86,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000,
        "entranceVideoEmbedId": "SR1SiqiIL0M",
        "dob": "1985-04-30"
    },
    {
        "id": "kennyomega",
        "name": "Kenny Omega",
        "image": "//static.wixstatic.com/media/ac2041_2e418e5aa56f4a5090a9e34bb8ac93bd~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_2e418e5aa56f4a5090a9e34bb8ac93bd~mv2.jpg",
        "points": 92,
        "cost": 70000,
        "goalIds": [
            "a-mens"
        ],
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "5vHpRoIpaU0"
    },
    {
        "id": "hangman-adam-page",
        "name": "Adam Page",
        "nickname": "The Hangman",
        "image": "//static.wixstatic.com/media/ac2041_6f7e4745a4ff4686be6682cae902d81a~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_6f7e4745a4ff4686be6682cae902d81a~mv2.jpg",
        "points": 90,
        "cost": 70000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "OM0ilkux9_M"
    },
    {
        "id": "adam-copeland",
        "name": "Adam Copeland",
        "nickname": "Edge",
        "image": "//static.wixstatic.com/media/815952_f495eb3bdd40430da99bc4749c5ef5ab~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_f495eb3bdd40430da99bc4749c5ef5ab~mv2.jpg",
        "points": 95,
        "cost": 75000,
        "followers": 5000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision"
        ]
    },
    {
        "id": "tommaso-ciampa",
        "name": "Ciampa",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/02/Tommaso_Pro--f883608f32c8af25f624174391141774.png",
        "points": 76,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "raw-tag"
        ],
        "followers": 5000,
        "damage": 30
    },
    {
        "id": "darbyallin",
        "name": "Darby Allin",
        "image": "//static.wixstatic.com/media/ac2041_d8f9802ad9ca4883a665970c4336064d~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_d8f9802ad9ca4883a665970c4336064d~mv2.jpg",
        "points": 85,
        "cost": 55000,
        "alignment": "GOOD",
        "goalIds": [
            "a-tnt"
        ],
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "jakehagar",
        "name": "Jake Hager",
        "image": "//static.wixstatic.com/media/ac2041_fd35ef4b44fe45148b3efa0d4c890df2~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_fd35ef4b44fe45148b3efa0d4c890df2~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "brian-cage",
        "name": "Brian Cage",
        "nickname": "The Machine",
        "image": "//static.wixstatic.com/media/815952_61cf653040894eb8aeed4b906d45f212~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_61cf653040894eb8aeed4b906d45f212~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "followers": 5000
    },
    {
        "id": "cash-wheeler",
        "name": "Cash Wheeler",
        "points": 88,
        "image": "//static.wixstatic.com/media/815952_6c3875f0a8d944a3816ffdeb7afea9b8~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_6c3875f0a8d944a3816ffdeb7afea9b8~mv2.jpg",
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "goalIds": [
            "a-tag-team"
        ],
        "popularity": 80,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 500000
    },
    {
        "id": "dax-harwood",
        "name": "Dax Harwood",
        "points": 88,
        "image": "//static.wixstatic.com/media/815952_92682116185244c6b47f082acd8390e9~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_92682116185244c6b47f082acd8390e9~mv2.jpg",
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "goalIds": [
            "a-tag-team"
        ],
        "popularity": 80,
        "charisma": 50,
        "stamina": 70,
        "morale": 30,
        "followers": 500000
    },
    {
        "id": "jonmoxley",
        "name": "Jon Moxley",
        "points": 93,
        "cost": 70000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 90,
        "morale": 50,
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_4e421de92f31466a87b2320fbfe44160~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_4e421de92f31466a87b2320fbfe44160~mv2.jpg"
    },
    {
        "id": "dean-ambrose",
        "name": "Dean Ambrose",
        "nickname": "Lunatic Fringe",
        "points": 0,
        "cost": 70000,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2018/12/Dean_Ambrose_Pro--7400785d2983a6022aab03bf6ef154d5.png",
        "alignment": "BAD",
        "brandIds": [
            "smackdown",
            "raw"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 90,
        "morale": 50,
        "followers": 5000,
        "active": false
    },
    {
        "id": "bron-breakker",
        "name": "Bron Breakker",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2023/07/Bron_07182023ej_0833_profile--dc5597071af45f8f40696aa81ff5f0fa.png",
        "points": 80,
        "cost": 60000,
        "alignment": "BAD",
        "popularity": 70,
        "charisma": 70,
        "stamina": 100,
        "morale": 90,
        "brandIds": [
            "raw"
        ],
        "followers": 500000
    },
    {
        "id": "kayden-carter",
        "name": "Kayden Carter",
        "points": 75,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/Kayden_Carter_Pro--7a055244954f6cfaa84d0a98538b6b76.png"
    },
    {
        "id": "katana-chance",
        "name": "Katana Chance",
        "points": 75,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/Kacy_Catanzaro_Pro--1b3c0edbf502527429d52f62f2808952.png"
    },
    {
        "id": "killswitch",
        "name": "KillSwitch",
        "image": "//static.wixstatic.com/media/815952_6094d38f2ac64641bbfb6c3b6a97bd33~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_6094d38f2ac64641bbfb6c3b6a97bd33~mv2.jpg",
        "points": 82,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "jeff-jarrett",
        "name": "Jeff Jarrett",
        "points": 83,
        "cost": 4000,
        "alignment": "BAD",
        "image": "//static.wixstatic.com/media/ac2041_f16cd177966a49f4a809176f46765233~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_f16cd177966a49f4a809176f46765233~mv2.jpg",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "matt-jackson",
        "name": "Matt Jackson",
        "image": "//static.wixstatic.com/media/ac2041_17b5c6d5a88d47ebb70ebeb86977665c~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_17b5c6d5a88d47ebb70ebeb86977665c~mv2.jpg",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "goalIds": [
            "a-tag-team"
        ],
        "followers": 5000
    },
    {
        "id": "nick-jackson",
        "name": "Nick Jackson",
        "image": "//static.wixstatic.com/media/ac2041_62e4cbefb51e4dd088bd3b8a1169fab1~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_62e4cbefb51e4dd088bd3b8a1169fab1~mv2.jpg",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "goalIds": [
            "a-tag-team"
        ],
        "followers": 5000
    },
    {
        "id": "scorpiosky",
        "name": "Scorpio Sky",
        "image": "//static.wixstatic.com/media/ac2041_a08fbb5067fe4f1e8e3f1453264bc458~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_a08fbb5067fe4f1e8e3f1453264bc458~mv2.jpg",
        "points": 70,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "goldberg",
        "name": "Goldberg",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Goldberg_pro.png",
        "points": 90,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "popularity": 80,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 100000,
        "active": false,
        "entranceVideoEmbedId": "wPcyW3eKL20"
    },
    {
        "id": "bret-hart",
        "name": "Bret Hart",
        "nickname": "Hitman",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Bret_Hart_bio.png",
        "points": 99,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "5mYXWOCgXQQ"
    },
    {
        "id": "vader",
        "name": "Vader",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Vader_bio.jpg",
        "points": 99,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "jim-neidhart",
        "name": 'Jim "The Anvil" Neidhart',
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Jim_The_Anvil_Neidhart_bio.png",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "awesome-kong",
        "name": "Awesome Kong",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Kharma_Pro.png",
        "gender": "FEMALE",
        "points": 80,
        "cost": 60000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "brittbaker",
        "name": "Britt Baker",
        "image": "//static.wixstatic.com/media/ac2041_4248a8d77b0143c683426778e2a04a37~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_4248a8d77b0143c683426778e2a04a37~mv2.jpg",
        "gender": "FEMALE",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "4t2zR_YeBng"
    },
    {
        "id": "lancehoyt",
        "name": "Lance Archer",
        "image": "//static.wixstatic.com/media/ac2041_730759ff79174f67977deaa6e74c14ea~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_730759ff79174f67977deaa6e74c14ea~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "miro",
        "name": "Miro",
        "image": "//static.wixstatic.com/media/ac2041_6a3c575c48794718a1aff5974322731d~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_6a3c575c48794718a1aff5974322731d~mv2.jpg",
        "points": 75,
        "cost": 4000,
        "goalIds": [
            "a-tnt"
        ],
        "alignment": "BAD",
        "brandIds": [
            "collision"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "FZMlq_MdmR0"
    },
    {
        "id": "paulwight",
        "name": "Paul Wight",
        "image": "//static.wixstatic.com/media/ac2041_96811aa105a94aada2a18e567d5c95f1~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_96811aa105a94aada2a18e567d5c95f1~mv2.jpg",
        "points": 20,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "damage": 50,
        "active": false
    },
    {
        "id": "mark-henry",
        "name": "Mark Henry",
        "image": "//static.wixstatic.com/media/ac2041_d20a8c3cb6c14dd28f81875d7510e908~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_d20a8c3cb6c14dd28f81875d7510e908~mv2.jpg",
        "points": 20,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "B0MslYif9iQ"
    },
    {
        "id": "big-e",
        "name": "Big E",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/02/Big_E_Profile--ac839d080afcadad4764eb2a660246c9.png",
        "points": 78,
        "cost": 65000,
        "alignment": "GOOD",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000,
        "damage": 80,
        "active": false,
        "entranceVideoEmbedId": "KzYFAZGF2KI"
    },
    {
        "id": "bray-wyatt",
        "name": "Bray Wyatt",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/10/SuperStar_Bray_Fiend--fdf9d5e3777cbff27bbe1ef6b0c1ece0.png",
        "points": 80,
        "cost": 70000,
        "alignment": "BAD",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 100,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "damage": 0,
        "active": false,
        "entranceVideoEmbedId": "_9KOXu24WK0"
    },
    {
        "id": "christian-cage",
        "name": "Christian Cage",
        "image": "//static.wixstatic.com/media/815952_36a8ce3139b645f8a821af0f2fe73233~mv2.jpg/v1/fill/w_238,h_238,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/champion-roster.jpg",
        "points": 90,
        "cost": 20000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "popularity": 80,
        "charisma": 90,
        "stamina": 60,
        "morale": 80,
        "followers": 500000
    },
    {
        "id": "ric-flair",
        "name": "Ric Flair",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Ric_Flair_bio.jpg",
        "points": 50,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 50,
        "morale": 50,
        "followers": 500000
    },
    {
        "id": "batista",
        "name": "Batista",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Batista_pro.png",
        "points": 89,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 90,
        "charisma": 80,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "shawn-michaels",
        "name": "Shawn Michaels",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/10/Shawn_Michaels_Pro--d4bc7c99be4fcec510501f5e7d25bde7.png",
        "points": 60,
        "cost": 500000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "active": false,
        "entranceVideoEmbedId": "j4ErmBDTOJo"
    },
    {
        "id": "powerhouse-hobbs",
        "name": "Powerhouse Hobbs",
        "image": "//static.wixstatic.com/media/ac2041_ef24370473334ce19061685295a6dcff~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_ef24370473334ce19061685295a6dcff~mv2.jpg",
        "brandIds": [
            "dynamite"
        ],
        "points": 93,
        "cost": 100000,
        "popularity": 90,
        "charisma": 90,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "shawn-michaels-hof",
        "name": "Shawn Michaels",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Shawn_Michaels_bio.jpg",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "entranceVideoEmbedId": "j4ErmBDTOJo"
    },
    {
        "id": "curt-hennig",
        "name": '"Mr. Perfect" Curt Hennig',
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/MrPerfect_bio.jpg",
        "points": 75,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "wcw"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "Hs8ANY_7WGI"
    },
    {
        "id": "randy-savage",
        "name": "Randy Savage",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Randy_Savage_bio.jpg",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "hulk-hogan",
        "name": "Hulk Hogan",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Hulk_Hogan_Bio.jpg",
        "points": 99,
        "cost": 100000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "dob": "1953-08-11"
    },
    {
        "id": "lex-luger",
        "name": "Lex Luger",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Lex_Luger_pro.png",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000,
        "dob": "1958-10-12"
    },
    {
        "id": "scott-steiner",
        "name": "Scott Steiner",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Scott_Steiner_pro.png",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "yokozuna",
        "name": "Yokozuna",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Yokozuna_pro.png",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "eVg0tD8B8hs"
    },
    {
        "id": "nick-aldis",
        "name": "Nick Aldis",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2023/10/NickAldis_Profile--46b47aba04960d9566b3857973b9064b.png",
        "points": 50,
        "cost": 75000,
        "alignment": "GOOD",
        ...sd,
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 80,
        "followers": 50000,
        "active": false
    },
    {
        "id": "rick-steiner",
        "name": "Rick Steiner",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Rick_Steiner_pro.png",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw",
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "rikishi",
        "name": "Rikishi",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Rikishi_pro.png",
        "points": 79,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "kurt-angle",
        "name": "Kurt Angle",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/04/Kurt_Angle_Pro--fbea630c97a81dc7c4d0a9717a90cb0e.png",
        "points": 89,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "mick-foley",
        "name": "Mick Foley",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2017/01/Mick_Foley_pro--c1befb9f840bb7d13c0fbf682f0d4a1e.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "jim-ross",
        "name": "Jim Ross",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Jim_Ross_bio.png",
        "points": 1,
        "cost": 0,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "eddie-guerrero",
        "name": "Eddie Guerrero",
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Eddie_Guerrero_bio.png",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "eddie-kingston",
        "name": "Eddie Kingston",
        "image": "//static.wixstatic.com/media/815952_1311c973870f417a8bb277e3cf8e9605~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_1311c973870f417a8bb277e3cf8e9605~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "followers": 5000,
        "damage": 50,
        "active": false
    },
    {
        "id": "keithlee",
        "name": "Keith Lee",
        "image": "//static.wixstatic.com/media/815952_2db4177145ee48478c554b138bfef465~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_2db4177145ee48478c554b138bfef465~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "jeffhardy",
        "name": "Jeff Hardy",
        "image": "//static.wixstatic.com/media/ac2041_3e9d0102a70b4935a7be91c1dc129a70~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_3e9d0102a70b4935a7be91c1dc129a70~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "goalIds": [
            "a-tag-team"
        ],
        "followers": 5000,
        "damage": 30
    },
    {
        "id": "matthardy",
        "name": "Matt Hardy",
        "image": "//static.wixstatic.com/media/ac2041_760b30b92e2a454bb6635f8d6edfd93d~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_760b30b92e2a454bb6635f8d6edfd93d~mv2.jpg",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "goalIds": [
            "a-tag-team"
        ],
        "followers": 500000
    },
    {
        "id": "kofi-kingston",
        "name": "Kofi Kingston",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/02/KOFI_10192020jg_0068_Profile--f57d753bfd0b4ab98952d563c12df0bd.png",
        "points": 80,
        "charisma": 80,
        "stamina": 60,
        "morale": 90,
        "role": ROLES.CRUISER,
        "followers": 50000,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "popularity": 80,
        "damage": 20,
        "active": false,
        "entranceVideoEmbedId": "PdnBh3mOl9U"
    },
    {
        "id": "rhea-ripley",
        "name": "Rhea Ripley",
        "role": ROLES.SPECIALIST,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2022/11/Rhea_Ripley_PROFILE--ac5c255a78b5832933e2e0e1e8a9f51e.png",
        "gender": "FEMALE",
        "points": 96,
        "cost": 60000,
        "alignment": "BAD",
        "damage": 90,
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "damian-priest",
        "name": "Damian Priest",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/04/Damien_Priest_Profile--769e2bd4aad556da498ade7f24a40d02.png",
        "points": 86,
        "cost": 60000,
        "role": ROLES.BRUISER,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "michin",
        "name": "Michin",
        "gender": "FEMALE",
        "role": ROLES.BRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/12/Mia_11262022hm_034_profile--e46b49de25805ad20af7ab299efe4ab2.png",
        "points": 70,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "bianca-belair",
        "name": "Bianca Belair",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/06/BIANCA_01282023sb0191_profile--5bfca1f3bf0f164e92476e3a84077bff.png",
        "gender": "FEMALE",
        "points": 95,
        "cost": 70000,
        "role": ROLES.FIGHTER,
        "alignment": "GOOD",
        ...sd,
        "popularity": 90,
        "charisma": 80,
        "stamina": 80,
        "morale": 80,
        "followers": 50000
    },
    {
        "id": "jey-uso",
        "name": "Jey Uso",
        "nickname": "Main Event",
        "role": ROLES.FIGHTER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/02/USO_10302020ej_0003300033_Profile--af838185bf78dcb0d3bb0f9873f26611.png",
        "points": 90,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "world-heavyweight"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "tscAN8W0QgU"
    },
    {
        "id": "sami-zayn",
        "name": "Sami Zayn",
        "role": ROLES.FIGHTER,
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/06/Sami_Zayn_Profile--4f993ee786bf3de7f75d3290db9d0aab.png",
        "points": 87,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "christopher-daniels",
        "name": "Christopher Daniels",
        "image": "//static.wixstatic.com/media/ac2041_e0ad25f5907247109a07dc3799b35d57~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_e0ad25f5907247109a07dc3799b35d57~mv2.jpg",
        "points": 75,
        "cost": 4000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "frankie-kazarian",
        "name": "Frankie Kazarian",
        "image": "//d2isjg8ovcm7q0.cloudfront.net/sites/default/files/frankie.png",
        "points": 75,
        "cost": 4000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "cm-punk",
        "name": "CM Punk",
        "nickname": "Best in the World",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/CM_Punk_pro.png",
        "points": 98,
        "role": ROLES.FIGHTER,
        "cost": 100000,
        "brandIds": [
            "raw"
        ],
        "alignment": "GOOD",
        "popularity": 100,
        "charisma": 100,
        "stamina": 60,
        "morale": 80,
        "wins": 691,
        "losses": 422,
        "streak": 2,
        "damage": 50,
        "active": false,
        "followers": 1000000
    },
    {
        "id": "nick-wayne",
        "name": "Nick Wayne",
        "points": 70,
        "cost": 5000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 60,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 5000,
        "image": "//static.wixstatic.com/media/815952_93413fbf9c9041cd9dbc0fa4ce6a04d0~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_93413fbf9c9041cd9dbc0fa4ce6a04d0~mv2.jpg"
    },
    {
        "id": "mjf",
        "name": "MJF",
        "image": "//static.wixstatic.com/media/ac2041_47bb5e63897146be9ee292954aa5e171~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_47bb5e63897146be9ee292954aa5e171~mv2.jpg",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision",
            "roh"
        ],
        "followers": 5000
    },
    {
        "id": "orange-cassidy",
        "name": "Orange Cassidy",
        "image": "//static.wixstatic.com/media/ac2041_a4f95afc48da4a5c95514bf2a3093f41~mv2.jpg/v1/fill/w_238,h_238,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/champion-roster.jpg",
        "points": 85,
        "cost": 65000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "pac",
        "name": "Pac",
        "role": ROLES.CRUISER,
        "image": "//static.wixstatic.com/media/ac2041_63ba4c0a12be4407adb914ffc035e459~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_63ba4c0a12be4407adb914ffc035e459~mv2.jpg",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "pentagon-jr",
        "name": "Pentagon Jr",
        "image": "//vignette.wikia.nocookie.net/svr06/images/8/88/Pentagon_jr_-_Copy_%282%29.png/revision/latest/scale-to-width-down/1000?cb=20190331015806",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "rey-fenix",
        "name": "Rey Fenix",
        "image": "//static.wixstatic.com/media/815952_c8a8f23457e842de983d3f0167122ff9~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_c8a8f23457e842de983d3f0167122ff9~mv2.jpg",
        "points": 75,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "santana",
        "name": "Santana",
        "image": "//static.wixstatic.com/media/ac2041_c24e0f536cbc436cb3b18d50cd5e7b39~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_c24e0f536cbc436cb3b18d50cd5e7b39~mv2.jpg",
        "points": 75,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "the-butcher",
        "name": "The Butcher",
        "points": 75,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_08d88cdd8df44a28b0a1c016683105c8~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_08d88cdd8df44a28b0a1c016683105c8~mv2.jpg"
    },
    {
        "id": "buddy-matthews",
        "name": "Buddy Matthews",
        "points": 85,
        "cost": 10000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/815952_4768a308d9284578a203f55cd8c4e44a~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_4768a308d9284578a203f55cd8c4e44a~mv2.jpg"
    },
    {
        "id": "wardlow",
        "name": "Wardlow",
        "role": ROLES.GIANT,
        "points": 75,
        "goalIds": [
            "a-mens"
        ],
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/815952_d546962182084410b79936f38e959f4c~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_d546962182084410b79936f38e959f4c~mv2.jpg"
    },
    {
        "id": "alexa-bliss",
        "name": "Alexa Bliss",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/05/Alexa_Bliss_Profile--185973455ed41cf1d692a71e9d124eee.png",
        "gender": "FEMALE",
        "role": ROLES.SPECIALIST,
        "points": 80,
        "cost": 4000,
        "alignment": "GOOD",
        "active": false,
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "damage": 100
    },
    {
        "id": "johnny-tv",
        "name": "Johnny TV",
        "image": "//static.wixstatic.com/media/815952_6736b8ebcf974744b41db6ae24fd2c53~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_6736b8ebcf974744b41db6ae24fd2c53~mv2.jpg",
        "points": 75,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "shinsuke-nakamura",
        "name": "Shinsuke Nakamura\xa0",
        "role": ROLES.SPECIALIST,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/02/Shinsuke_Nakamura_Profile--eedc5cabb7ca26774d76c0c6ff595c70.png",
        "points": 84,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "popularity": 50,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "iyo-sky",
        "name": "Iyo Sky",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2022/02/Io_Shirai_Profile--c9207e8ae13d62b1c32f8ff0c8a011cc.png",
        "gender": "FEMALE",
        "points": 88,
        "cost": 4000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "toni-storm",
        "name": "Toni Storm",
        "image": "//static.wixstatic.com/media/815952_dfccd06f9cc84ae1be41721e08341d62~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_dfccd06f9cc84ae1be41721e08341d62~mv2.jpg",
        "gender": "FEMALE",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "goalIds": [
            "a-womens"
        ],
        "followers": 5000
    },
    {
        "id": "the-miz",
        "name": "The Miz",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/05/The_Miz_pro--f4e98cf4a7d4acc8e418ddf0f949e95e.png",
        "points": 85,
        "cost": 65000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "rey-mysterio",
        "name": "Rey Mysterio",
        "role": ROLES.CRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/02/Rey_Mysterio_Profile--374bca8222ccd3775e811f3c5e70bded.png",
        "points": 85,
        "goalIds": [
            "us"
        ],
        "cost": 65000,
        "alignment": "GOOD",
        ...sd,
        "popularity": 50,
        "charisma": 50,
        "stamina": 50,
        "damage": 20,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "tegan-nox",
        "name": "Tegan Nox",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/12/Tegan_12092022hm_00147_profile--2cd28215a66973890604f3fd77e59acc.png",
        "gender": "FEMALE",
        "points": 75,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "pete-dunne",
        "name": "Pete Dunne",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2020/01/Pete_Dunne_Pro--f790b29f0cbcf7893968d8625bc96281.png",
        "points": 75,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "smackdown",
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "xavier-woods",
        "name": "Xavier Woods",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/03/Xavi_Pro--11bd21a3f24330f0667e2c0b476f3aaa.png",
        "points": 78,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "sheamus",
        "name": "Sheamus",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/08/69640_Sheamus_12202019rf_056_Profile--e78f54cfb27b1ded3e1663a36ddc3175.png",
        "points": 86,
        "cost": 65000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "entranceVideoEmbedId": "wi22Xgxx-Ak"
    },
    {
        "id": "dolph-ziggler",
        "name": "Nic Nemeth",
        "brandIds": [
            "tna"
        ],
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/07/DOLPH_02052021ej_00063_Profile--6a06df61d18ec0d0646204fb16af373c.png",
        "points": 85,
        "cost": 50000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "cameron-grimes",
        "name": "Cameron Grimes",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/01/Cameron_Grimes_Profile--94d9ba59e3d3ac824a3ab4b2794930ab.png",
        "points": 73,
        "cost": 50000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "austin-theory",
        "name": "Austin Theory",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2022/07/Theory_PROFILE--b8f13b2a5825ec980ce97a2f05cbf3b2.png",
        "points": 72,
        "cost": 100000,
        "alignment": "BAD",
        ...sd,
        "popularity": 80,
        "charisma": 50,
        "stamina": 50,
        "morale": 80,
        "followers": 500000
    },
    {
        "id": "shotzi",
        "name": "Shotzi",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/08/Shotzi_07282023ca_098_profile--5969fe88e68e204ae683333ab7f6f790.png",
        "gender": "FEMALE",
        "points": 76,
        "cost": 55000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "zoey-stark",
        "name": "Zoey Stark",
        "gender": "FEMALE",
        "points": 78,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/Zoey_Stark_PROFILE--e21a485ac636e7db6ccfe8e332886baf.png"
    },
    {
        "id": "jd-mcdonagh",
        "name": "JD McDonagh",
        "points": 71,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/JDMcDonagh_07122022PM_2813_profile--00f8b80d6b3448b305174afa692868f1.png"
    },
    {
        "id": "dustin-rhodes",
        "name": "Dustin Rhodes",
        "image": "//static.wixstatic.com/media/ac2041_682e1e72158e4b93abcac41fc46aed29~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_682e1e72158e4b93abcac41fc46aed29~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "ricky-starks",
        "name": "Ricky Starks",
        "points": 85,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/815952_e6cef4a13e4541ed9c2c9ed6b2496ddc~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_e6cef4a13e4541ed9c2c9ed6b2496ddc~mv2.jpg"
    },
    {
        "id": "big-bill",
        "name": "Big Bill",
        "image": "//static.wixstatic.com/media/815952_6d1a8b535efc4982b5b3f93d6fea808c~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_6d1a8b535efc4982b5b3f93d6fea808c~mv2.jpg",
        "points": 85,
        "cost": 55000,
        "role": ROLES.GIANT,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "rubysoho",
        "name": "Ruby Soho",
        "gender": "FEMALE",
        "points": 85,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_4ac0989310414c97ad3eb00813549b77~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_4ac0989310414c97ad3eb00813549b77~mv2.jpg"
    },
    {
        "id": "bryandanielson",
        "name": "Bryan Danielson",
        "image": "//static.wixstatic.com/media/ac2041_4be0f657455e4d0da225c99df298944a~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_4be0f657455e4d0da225c99df298944a~mv2.jpg",
        "points": 96,
        "cost": 70000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "daniel-bryan",
        "name": "Daniel Bryan",
        "points": 0,
        "cost": 70000,
        "alignment": "GOOD",
        ...sd,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2020/01/Daniel_Bryan_Pro--bfcf96f308903d00574ccf88318215f0.png",
        "popularity": 100,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 50000,
        "active": false
    },
    {
        "id": "piper-niven",
        "name": "Piper Niven",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/PiperNiven_02062023PM_00180_profile--502864446f46be9e22b443d2d8dc67c4.png",
        "gender": "FEMALE",
        "points": 75,
        "cost": 15000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "jungleboy",
        "name": "Jungle Boy",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "marq-quen",
        "name": "Marq Quen",
        "image": "//static.wixstatic.com/media/ac2041_718f1537db2a423ab8f232f2c4631d70~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_718f1537db2a423ab8f232f2c4631d70~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "ortiz",
        "name": "Ortiz",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_d15754c2b7234ed7b8cf23db19c8fa89~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_d15754c2b7234ed7b8cf23db19c8fa89~mv2.jpg"
    },
    {
        "id": "samoa-joe",
        "name": "Samoa Joe",
        "points": 95,
        "goalIds": [
            "a-mens"
        ],
        "cost": 155000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/815952_19863be71db34ca9b9e3c5665b76612b~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_19863be71db34ca9b9e3c5665b76612b~mv2.jpg"
    },
    {
        "id": "sammyguevara",
        "name": "Sammy Guevara",
        "image": "//static.wixstatic.com/media/ac2041_27872e8c1599428ea82c780a432327ec~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_27872e8c1599428ea82c780a432327ec~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "stu-grayson",
        "name": "Stu Grayson",
        "image": "//prowrestlingnewshub.com/wp-content/uploads/2020/03/Stu-Grayson-768x619.png",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "kairi-sane",
        "name": "Kairi Sane",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/11/Kairi_11102023MM_5697_Profile--ae52fd356b886b7683ee19cd1d98ac4a.png",
        "gender": "FEMALE",
        ...sd,
        "points": 83,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "malakai-black",
        "name": "Malakai Black",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "image": "//static.wixstatic.com/media/815952_8c73cd69ef034de2be80fdec5b7506ff~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_8c73cd69ef034de2be80fdec5b7506ff~mv2.jpg"
    },
    {
        "id": "julia-hart",
        "name": "Julia Hart",
        "gender": "FEMALE",
        "points": 80,
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "image": "//static.wixstatic.com/media/815952_71d946355eea4c299b7378dc4c05e8f9~mv2.jpg/v1/fill/w_520,h_520,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Image-empty-state.jpg"
    },
    {
        "id": "the-blade",
        "name": "The Blade",
        "image": "//static.wixstatic.com/media/ac2041_7ccb67f8875f4647aabbc423cce48eb6~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_7ccb67f8875f4647aabbc423cce48eb6~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "trent",
        "name": "Trent",
        "image": "//static.wixstatic.com/media/ac2041_26c789aef6e94e7192d0ed42471b085c~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_26c789aef6e94e7192d0ed42471b085c~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "hikaru-Shida",
        "name": "Hikaru Shida",
        "image": "//static.wixstatic.com/media/815952_a9a09977f70c423da1d94c4abd4514df~mv2.jpg/v1/fill/w_238,h_238,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/champion-roster.jpg",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "krisstatlander",
        "name": "Kris Statlander",
        "image": "//static.wixstatic.com/media/ac2041_e7ace840f18a4a4ca46f6a49327c0a2d~mv2.jpg/v1/fill/w_238,h_238,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/champion-roster.jpg",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "damage": 30,
        "active": false
    },
    {
        "id": "nylarose",
        "name": "Nyla Rose",
        "image": "//static.wixstatic.com/media/ac2041_c17f728b4f3b468b9c6b4a7d077f32fc~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_c17f728b4f3b468b9c6b4a7d077f32fc~mv2.jpg",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "penelope-ford",
        "name": "Penelope Ford",
        "image": "//static.wixstatic.com/media/ac2041_bb6fc9af3cd24209b5662f6bec57b33a~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_bb6fc9af3cd24209b5662f6bec57b33a~mv2.jpg",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "the-bunny",
        "name": "The Bunny",
        "image": "//static.wixstatic.com/media/ac2041_f9da4b54a61d4e26a8e58da062619285~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_f9da4b54a61d4e26a8e58da062619285~mv2.jpg",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "yuka-sakazaki",
        "name": "Yuka Sakazaki",
        "image": "//static.wixstatic.com/media/ac2041_9017759f2d2a4b3b89589671fe56ba23~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_9017759f2d2a4b3b89589671fe56ba23~mv2.jpg",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "chyna",
        "name": "Chyna",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/2016/05/Chyna_pro--e46ef6285ff07d70ec5792b888df587c.png",
        "points": 65,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000
    },
    {
        "id": "humberto-carrillo",
        "name": "Humberto",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Humberto_Carrillo_Pro--6e67f1049e31a48a849e1f795212b4ba.png",
        "points": 65,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "carmelo-hayes",
        "name": "Carmelo Hayes",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2022/09/Carmello_Hayes_PROFILE--c3ff848b7787bd8508b99c09b7be03dd.png",
        "points": 81,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "smackdown"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 90,
        "morale": 90,
        "followers": 500000
    },
    {
        "id": "apollo-crews",
        "name": "Apollo Crews",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/ApolloCrews_07122022PM_4001_profile--b8d2a2b039636a09c9cdb87a3491c4ec.png",
        "points": 71,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "popularity": 50,
        "charisma": 30,
        "stamina": 60,
        "morale": 30,
        "followers": 5000
    },
    {
        "id": "johnny-gargano",
        "name": "Johnny Gargano",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/09/Johnny_Gargano_PROFILE--0274603faa581257f5b8742dfbcccda0.png",
        "points": 74,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "raw-tag"
        ],
        "popularity": 90,
        "charisma": 40,
        "stamina": 70,
        "morale": 50,
        "followers": 5000,
        "damage": 30,
        "active": false
    },
    {
        "id": "candice-lerae",
        "name": "Candice LeRae",
        "gender": "FEMALE",
        "points": 67,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/10/Candice_LaRae_PROFILE--def0e1f21f051d008260b704d49aa993.png"
    },
    {
        "id": "riho",
        "name": "Riho",
        "image": "//static.wixstatic.com/media/ac2041_34d14cba453b40749381f183e7ded1d3~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_34d14cba453b40749381f183e7ded1d3~mv2.jpg",
        "gender": "FEMALE",
        "points": 81,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "mustafa-ali",
        "name": "Mustafa Ali",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Mustafa_Ali_PROFILE--c5d0cc5ad016bc682128a7b7e4033ea8.png",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "ricochet",
        "name": "Ricochet ",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/02/Ricochet_Pro--6945ce77823f2d00e33e54eeb3921648.png",
        "points": 81,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "ic"
        ],
        "followers": 5000
    },
    {
        "id": "bobby-roode",
        "name": "Robert Roode",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/05/Robert_Roode_Pro--df5647fa8e42b990dfa6aab89754cfea.png",
        "points": 80,
        "cost": 50000,
        "alignment": "BAD",
        "followers": 5000,
        "damage": 90,
        "active": false
    },
    {
        "id": "santos-escobar",
        "name": "Santos Escobar",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Santos_Escobar_PROFILE--a20bd6ea1d579d085ad60dda7d6a3dec.png",
        "points": 80,
        "cost": 60000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "dexter-lumis",
        "name": "Dexter Lumis",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/11/DexterLumis_Pro--bf841e559e32c134631935cf18208a6c.png",
        "points": 66,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/Naomi_Profile--3f333473c2d5d48b94cc205962794d85.png",
        "id": "naomi",
        "name": "Naomi",
        "gender": "FEMALE",
        "points": 80,
        "cost": 60000,
        "goalIds": [
            "womens-championship"
        ],
        "alignment": "NEUTRAL",
        "brandIds": [
            "smackdown"
        ],
        "followers": 5000
    },
    {
        "id": "angel-garza",
        "name": "Angel",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/09/Angel_Garza_Pro--12c90ef3a57a9bde157c6182d3a4393e.png",
        "points": 67,
        "cost": 3000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "mvp",
        "name": "MVP",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/07/MVP_11302020ej_00600_Profile--27bd19a9c45f625d6551b2e6b9f30291.png",
        "points": 68,
        "cost": 3000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "sonya-deville",
        "name": "Sonya Deville",
        "gender": "FEMALE",
        "points": 74,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/05/Sonya_Deville_Profile--5a83db22c9346ec38734fd3a6eb333db.png"
    },
    {
        "id": "chelsea-green",
        "name": "Chelsea Green",
        "gender": "FEMALE",
        "points": 72,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/07/Sonya_Chelsea_07172023rf_0090_Profile--de77e48c9d44b13e7c661a445dceeb97.png"
    },
    {
        "id": "angelo-dawkins",
        "name": "Angelo Dawkins",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/11/AgeloDawkins_Pro--1a14067ea377d2bb3b94e9746e215620.png",
        "points": 74,
        "cost": 55000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "otis",
        "name": "Otis",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/Otis_PROFILE--170b5e9c61397baa6b73480340fc79c3.png",
        "points": 74,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "natalya",
        "name": "Natalya",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/02/Natalya_Profile--670940c95bdc4d0cb3aebfdec7e1fe84.png",
        "gender": "FEMALE",
        "points": 81,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "corbin",
        "name": "Corbin",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/10/Baron_Corbin_PROFILE--966d7a3d78f004cd0865721e96f88490.png",
        "points": 76,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "smackdown"
        ],
        "followers": 5000
    },
    {
        "id": "oba-femi",
        "name": "Oba Femi",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/01/ObaFemi_01092024AK_03509_Profile--d6be007443ccc590063253b53ada9dd2.png",
        "points": 80,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 50000
    },
    {
        "id": "tamina",
        "name": "Tamina",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Tamina_Pro--c9d3386662a2008025f8c7d6e89b8564.png",
        "gender": "FEMALE",
        "points": 67,
        "cost": 55000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "chad-gable",
        "name": "Chad Gable",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/Chad_Gable_PROFILE--fa78c8d49c2d639c742efe4ce9d962eb.png",
        "points": 80,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "ic"
        ],
        "followers": 5000
    },
    {
        "id": "raquel-gonzalez",
        "name": "Raquel Rodriguez",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/06/Raquel_LIV__04172023ca_0339_profile--e5099fb96a1c954e0a75537a5f58ec54.png",
        "gender": "FEMALE",
        "points": 80,
        "cost": 40000,
        "active": false,
        "damage": 50,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 50000
    },
    {
        "id": "xia-li",
        "name": "Xia Li",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Xia_Li_PROFILE--95d560e0be0bb725b5865310fb4ad461.png",
        "gender": "FEMALE",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "swervestrickland",
        "name": "Swerve Strickland",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_49f11e654f7d4d43bd26c4fe82d8f438~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_49f11e654f7d4d43bd26c4fe82d8f438~mv2.jpg"
    },
    {
        "id": "ludwig-kaiser",
        "name": "Ludwig Kaiser",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/09/Ludwig_Kaiser_PROFILE--772d2e447b458a0453abc3758fde6732.png",
        "points": 73,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "roderick-strong",
        "name": "Roderick Strong",
        "image": "//static.wixstatic.com/media/ac2041_45e2ec333aab454f8f2017138b52cd1b~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_45e2ec333aab454f8f2017138b52cd1b~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "braun-strowman",
        "name": "Braun Strowman",
        "points": 82,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "popularity": 60,
        "charisma": 50,
        "stamina": 50,
        "morale": 40,
        "followers": 50000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/08/Braun_Strowman_Pro--4264c86af159cd9ab0a49e4eabeb4ed3.png",
        "damage": 100,
        "active": false
    },
    {
        "id": "bobby-fish",
        "name": "Bobby Fish",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/07/Bobby_Fish_06012021cg_041_Profile--fabfc8eeecd85439b28d4cd36a6b355c.png",
        "points": 70,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [],
        "followers": 5000
    },
    {
        "id": "drake-maverick",
        "name": "Drake Maverick",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/02/DRAKE_07032020jg_0090_Profile--c64a3e776ba03568c9165252221a5a13.png",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "angelico",
        "name": "Angelico",
        "image": "//vignette.wikia.nocookie.net/prowrestling/images/b/b2/Angelico2015.jpg/revision/latest?cb=20170619185447",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "chuck-taylor",
        "name": "Chuck Taylor",
        "image": "//static.wixstatic.com/media/815952_9705b31f4c2642fda164d65fbdc0790c~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_9705b31f4c2642fda164d65fbdc0790c~mv2.jpg",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "ethan-page",
        "name": "Ethan Page",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_1376eba259124d69836cb6075b8579a1~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_1376eba259124d69836cb6075b8579a1~mv2.jpg"
    },
    {
        "id": "evil-uno",
        "name": "Evil Uno",
        "image": "//static.wixstatic.com/media/ac2041_bf80ffad81444b5db1b0c3681129ea52~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_bf80ffad81444b5db1b0c3681129ea52~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "isiah-kassidy",
        "name": "Isiah Kassidy",
        "image": "//static.wixstatic.com/media/ac2041_13121a5b69f145989e25f48305afdae2~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_13121a5b69f145989e25f48305afdae2~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "kip-sabian",
        "name": "Kip Sabian",
        "image": "//static.wixstatic.com/media/ac2041_ecf87aa2df5945519a154cfce2ac4f77~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_ecf87aa2df5945519a154cfce2ac4f77~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "michael-nakazawa",
        "name": "Michael Nakazawa",
        "image": "//static.wixstatic.com/media/ac2041_f9a537cdf2364821ab53242d8149fe65~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_f9a537cdf2364821ab53242d8149fe65~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "spears",
        "name": "Shawn Spears",
        "image": "//static.wixstatic.com/media/ac2041_b4d8b1b85a6348d4b61b482e69a22028~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_b4d8b1b85a6348d4b61b482e69a22028~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "karrion-kross",
        "name": "Karrion Kross",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/Karrion_Kross_PROFILE--fe49ad44c9b95d5777e0e4cd6c1d835b.png",
        "points": 75,
        "cost": 60000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "carlito",
        "name": "Carlito",
        "image": " //www.wwe.com/f/styles/talent_champion_s/public/all/2023/10/Carlito_PROFILE--4aa466892d0fdd170f52825d9ed5f66d.png",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        ...sd,
        "damage": 50,
        "followers": 5000
    },
    {
        "id": "scarlett",
        "name": "Scarlett",
        "gender": "FEMALE",
        "points": 69,
        "cost": 3000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/Scarlet_Bordeaux_PROFILE--64a98a81f37e61c17c70970e36013ee1.png"
    },
    {
        "id": "ashante-adonis",
        "name": "Ashante Adonis",
        "points": 62,
        "cost": 3000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/09/Ashtante_Adonis_PROFILE--16b3f22af24ee531a4d409abe929e6b2.png"
    },
    {
        "id": "b-fab",
        "name": "B-Fab",
        "gender": "FEMALE",
        "points": 66,
        "cost": 3000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "popularity": 50,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/09/B_Fab_PROFILE--357a17020cf0b87a70c5d60723fa05c4.png"
    },
    {
        "id": "leva-bates",
        "name": "Leva Bates",
        "image": "//images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/ce33d7dc-eeb1-4900-be73-3c00611e37af/db55l9e-3e67dd76-370d-4f94-9923-16921bf09959.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3sicGF0aCI6IlwvZlwvY2UzM2Q3ZGMtZWViMS00OTAwLWJlNzMtM2MwMDYxMWUzN2FmXC9kYjU1bDllLTNlNjdkZDc2LTM3MGQtNGY5NC05OTIzLTE2OTIxYmYwOTk1OS5wbmcifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6ZmlsZS5kb3dubG9hZCJdfQ.xHUCxYtNnIBgDPyTzvSZKex58GnKcv7ndwadhh8FnfA",
        "gender": "FEMALE",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "sadie-gibbs",
        "name": "Sadie Gibbs",
        "gender": "FEMALE",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "meiko-satomura",
        "name": "Meiko Satomura",
        "gender": "FEMALE",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/06/NXTUK_Studio_London_02072021AT_0851_Meiko_Profile--2b793031752d2f129bf595e6e2df6335.png"
    },
    {
        "id": "noam-dar",
        "name": "Noam Dar",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/02/NXTUK_London_10052020at_06193_Noam_Dar_Profile--fc44bf3c67cb6b7439fd04d73748d804.png",
        "points": 76,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "ilja-dragunov",
        "name": "Ilja Dragunov ",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/Ilja_Dragunov_PROFILE--8a37740cddfedd3de5c75d91b1994d05.png",
        "points": 81,
        "cost": 10000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "popularity": 50,
        "charisma": 50,
        "stamina": 90,
        "morale": 100,
        "followers": 50000
    },
    {
        "id": "gigi-dolin",
        "name": "Gigi Dolin",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Gigi_Dolan_Profile--96a681d8155dc6e223bf61b4b8982692.png",
        "gender": "FEMALE",
        "points": 60,
        "cost": 3000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "zelina-vega",
        "name": "Zelina Vega",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Zelina_Vega_PROFILE--597c416b967f884a46e5735f28f92e6c.png",
        "gender": "FEMALE",
        "points": 74,
        "cost": 3000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "raul-mendoza",
        "name": "Raul Mendoza",
        "points": 60,
        "cost": 3000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Crus_Del_Toro_PROFILE--1153c6dc4de7cfb57e997efd770adb6f.png"
    },
    {
        "id": "joaquin-wilde",
        "name": "Joaquin Wilde",
        "points": 60,
        "cost": 3000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Joaquin_Wilde_PROFILE--5774722603ceee6773046dfa9dd8c9cc.png"
    },
    {
        "id": "alicia-taylor",
        "name": "Alicia Taylor",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Alicia_Taylor_Pro--3cae547ab9d02803932e51775a36e208.png",
        "gender": "FEMALE",
        "points": 1,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "amale",
        "name": "Amale",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/Amale_Profile--8840ff8beccd6fefafabbc20815337a5.png",
        "gender": "FEMALE",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "amari-miller",
        "name": "Amari Miller",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/09/Amari_Miller_06082021cg_014_Profile--e784acb025495f0875d0cf909d2c398d.png",
        "gender": "FEMALE",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "andre-chase",
        "name": "Andre Chase",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/11/Andre_Chase_Pro--ea5cefc51936d3f2ca9e4d384f50b6ef.png",
        "points": 73,
        "cost": 3000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "lyra-valkyria",
        "name": "Lyra Valkyria",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/12/LyraValkyria_12062022BR_02107_profile--5820d5eebcdfdc60ea48aafa9099a685.png",
        "gender": "FEMALE",
        "points": 84,
        "cost": 3000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "ashton-smith",
        "name": "Ashton Smith",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/02/NXTUK_London_10052020at_02628_Ashton_Smith_Profile--4da6dcdf2ec2f84a9732af6dc55263ad.png",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "beth-phoenix",
        "name": "Beth Phoenix",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/06/Beth_Phoenix_Pro--15ecd3bb7c05f98fda366bfad4dfe595.png",
        "gender": "FEMALE",
        "points": 87,
        "cost": 3000,
        "alignment": "GOOD",
        "active": false,
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "boa",
        "name": "Boa",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/BOA_04042023AK_01379_Profile--ead10fe7ca85c3bf3eddd07774aa59c0.png",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "blair-davenport",
        "name": "Blair Davenport",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/Blair_Davenport_Profile--7d768e2a37ab5dea395e395c7bf7c563.png",
        "gender": "FEMALE",
        "points": 74,
        "cost": 3000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "brutus-creed",
        "name": "Brutus Creed",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Brutus_Creed_PROFILE--1225c44cf291493a8ebf3d852e28db47.png",
        "points": 78,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "charlie-dempsey",
        "name": "Charlie Dempsey",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/12/Charlie_Dempsey_PROFILE--150cb715c08d7b17c4d52e9bb18c65b9.png",
        "points": 64,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "dani-luna",
        "name": "Dani Luna",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/07/NXTUK_London_10052020at_09418_Dani_Luna_Profile--d6e80877473649ac14cdfaad7abdcc92.png",
        "gender": "FEMALE",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "cora-jade",
        "name": "Cora Jade",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/09/Cora_Jade_PROFILE--d746991cfffc26f1266a57dfc02619de.png",
        "gender": "FEMALE",
        "points": 74,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "dave-mastiff",
        "name": "Dave Mastiff",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/03/Dave_Mastiff_Profile--2dd1b24fc20e412113a3ab1c0aac00d9.png",
        "points": 70,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "tiffany-stratton",
        "name": "Tiffany Stratton",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2023/09/TiffanyStratton_05092023AK_01935_Profile--12ec883bc903d0e47c37ac32eb0e49a5.png",
        "gender": "FEMALE",
        "points": 80,
        "cost": 60000,
        "goalIds": [
            "womens-championship"
        ],
        "alignment": "BAD",
        "followers": 5000,
        ...sd
    },
    {
        "id": "duke-hudson",
        "name": "Duke Hudson",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Duke_Hudson_11082022pm_8484_profile--37c415c6bc10c66281aea06c5edb7ed0.png",
        "points": 71,
        "cost": 2000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "eddie-dennis",
        "name": "Eddie Dennis",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/09/70683_NXTUK_17042019_AT_0027_Profile--40ac33bab2ed330923977655cdf5aaab.png",
        "points": 55,
        "cost": 2000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "elektra-lopez",
        "name": "Elektra Lopez",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Elektra_Lopez_PROFILE--7d185b12387bbafd8eab136c5075bfb7.png",
        "gender": "FEMALE",
        "points": 55,
        "cost": 2000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "grayson-waller",
        "name": "Grayson Waller",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/11/Grayson_Waller_Pro--5acfc6d5f56947cc774bf1bc97c96d92.png",
        "points": 82,
        "cost": 55000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "gunther",
        "name": "Gunther",
        "nickname": "The ring general",
        "role": ROLES.BRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/04/Gunther_Profile--1daf55129a96ae5763f6a034324acd7d.png",
        "points": 90,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "indi-hartwell",
        "name": "Indi Hartwell",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/06/INDI_HARTWELL_04012023sb0113_profile--afa30887c9b8d2c3ba7529396a6f7a2c.png",
        "gender": "FEMALE",
        "points": 63,
        "cost": 30000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "isla-dawn",
        "name": "Isla Dawn",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/IslaDawn_04042023AK_00846_Profile--cce4460356a72d3305c6a075cf2b01fa.png",
        "gender": "FEMALE",
        "points": 74,
        "cost": 3000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "alba-fyre",
        "name": "Alba Fyre",
        "gender": "FEMALE",
        "points": 74,
        "cost": 3000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/AlbaFyre_04042023AK_00128_Profile--8c84dd63ee43142947ea3ac9e9e7a544.png"
    },
    {
        "id": "giovanni-vinci",
        "name": "Giovanni Vinci",
        "points": 72,
        "cost": 3000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/09/Giovanni_Vinci_PROFILE--0de7f5442b024833582b81b0175661b7.png"
    },
    {
        "id": "ivy-nile",
        "name": "Ivy Nile",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/IvyNile_Profile--8b37d4bd753353d96c8f440b1b04ab24.png",
        "gender": "FEMALE",
        "points": 73,
        "cost": 7000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "jacy-jayne",
        "name": "Jacy Jayne",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Jacy_Jayne_07202021ej_0254_Profile--089e457bd3dcf4da50c0a61c1b4ab36c.png",
        "gender": "FEMALE",
        "points": 73,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "jinny",
        "name": "Jinny",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/11/Jinny_Pro--864be565e373ce368e13a9fb77b143d3.png",
        "gender": "FEMALE",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "joe-coffey",
        "name": "Joe Coffey",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/NXTUK_LONDON_07062022_AT_1350_profile--3bf4459970b3f7cdc0d530631d718403.png",
        "points": 76,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "wolfgang",
        "name": "Wolfgang",
        "image": "//www.wwe.com/f/styles/talent_champion_xl/public/all/2023/02/Wolfgang_PROFILE--1cca55b92dd7c49e850054695efac436.png",
        "points": 73,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "joe-gacy",
        "name": "Joe Gacy",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/Joe_Gacy_Pro--d361802dc2c4b9fe6100d4d8ebc62d6c.png",
        "points": 73,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "julius-creed",
        "name": "Julius Creed",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Julius_Creed_PROFILE--1b96a89d6417eea604becd60b8ca9f41.png",
        "points": 79,
        "cost": 8000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "lash-legend",
        "name": "Lash Legend",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/12/Lash_Legend_Pro--b372cfa34ce6d45256fa8f12d230a52a.png",
        "gender": "FEMALE",
        "points": 65,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "mark-coffey",
        "name": "Mark Coffey",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/Mark_Coffey_PROFILE--472fbe2cc5abd582196d09e0ed38e466.png",
        "points": 74,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "nikkita-lyons",
        "name": "Nikkita Lyons",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/03/Nikkita_Lyons_Profile--30b1ca0748a9252cec83120699afdaa1.png",
        "gender": "FEMALE",
        "points": 65,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000,
        "damage": 40,
        "active": false
    },
    {
        "id": "nina-samuels",
        "name": "Nina Samuels",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Nina_Samuels_Pro--574f06d069b4e85723146dbba603af01.png",
        "gender": "FEMALE",
        "points": 65,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "saraya",
        "name": "Saraya",
        "image": "//static.wixstatic.com/media/815952_94a73050e3ea409fbf42b0b89d88234f~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_94a73050e3ea409fbf42b0b89d88234f~mv2.jpg",
        "gender": "FEMALE",
        "points": 85,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite"
        ],
        "goalIds": [
            "a-womens"
        ],
        "popularity": 80,
        "charisma": 90,
        "stamina": 50,
        "morale": 20,
        "damage": 30,
        "followers": 50000
    },
    {
        "id": "rampage-brown",
        "name": "Rampage Brown",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/02/NXTUK_London_10052020at_03621_Rampage_Brown_Profile--ace0245cd71b0b0bc449ae04ba84dba9.png",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "followers": 5000
    },
    {
        "id": "ridge-holland",
        "name": "Ridge Holland",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/RidgeHolland_Profile--b65ae05eba83ed7adf82fec45ab457a7.png",
        "points": 76,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "sarray",
        "name": "Sarray",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/03/Sarray_Profile--011d9e6c3ef9ce7f5d1a3100c053371e.png",
        "gender": "FEMALE",
        "points": 40,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "shanky",
        "name": "Shanky",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Shanky_Profile--02f7e6efcade81ca88cbfc4933321800.png",
        "points": 70,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "solo-sikoa",
        "name": "Solo Sikoa",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/11/Solo_Sikoa_Pro--c4b462cd8220e3e720a376fcc3486bff.png",
        "points": 86,
        "cost": 60000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "tony-dangelo",
        "name": "Tony D'Angelo",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/Tony_Dangelo_Pro--42da50ea0efdf6c083c7108852289ba1.png",
        "points": 75,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "stacks",
        "name": "Stacks",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2023/12/channinglorenzo_08012023ak_00485_profile_720--f46ed81e614c12d55ea1ae27236f24d7.png",
        "points": 69,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "rezar",
        "name": "Rezar",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2020/06/AOP_01202020rf_016_Profile--14f6df90b8a79147f9d2ccc456ffb376.png",
        "points": 82,
        "cost": 4000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "akam",
        "name": "Akam",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2019/12/Akam_Pro--ffee68e9195660673ab3aa07564f7c28.png",
        "points": 88,
        "cost": 4000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "paul-ellering",
        "name": "Paul Ellering",
        "active": false,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2016/07/Paul_Ellering_pro--f32f25f6d9ab8143ef48417aac564a3b.png",
        "points": 0,
        "cost": 500,
        "alignment": "BAD",
        "brandIds": [
            "smackdown"
        ]
    },
    {
        "id": "tyler-bate",
        "name": "Tyler Bate",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/TylerBate_01242023AK_01684_Profile--b314d00065dd54dd41bb33b9cbd069e9.png",
        "points": 76,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "trish-stratus",
        "name": "Trish Stratus",
        "gender": "FEMALE",
        "points": 89,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "popularity": 70,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 100000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/05/Trish_Stratus_PROFILE--861c35b5400b94574024228d0c55c4bf.png"
    },
    {
        "id": "trick-williams",
        "name": "Trick Williams",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/Trick_Williams_PROFILE--46d10050ee918ffb54a75508c4084187.png",
        "points": 78,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "wendy-choo",
        "name": "Wendy Choo",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/01/Karen_Choo_01042022_2274_Profile--187b23f988fe766bd8cd73634c99fb38.png",
        "gender": "FEMALE",
        "points": 72,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "wes-lee",
        "name": "Wes Lee",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/08/Wes_Lee_PROFILE--acdb43b00f7d61846852b6d24b8ada39.png",
        "points": 76,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "popularity": 70,
        "charisma": 60,
        "stamina": 30,
        "morale": 100,
        "damage": 80,
        "active": false,
        "followers": 50000
    },
    {
        "id": "bad-news-barrett",
        "name": "Wade Barrett",
        "role": ROLES.FIGHTER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/09/Wade_Barrett_Pro--09bceb6b90d372a0f07b81795f84b30f.png",
        "points": 20,
        "cost": 4000,
        "alignment": "GOOD",
        ...sd,
        "active": false,
        "followers": 5000
    },
    {
        "id": "xyon-quinn",
        "name": "Xyon Quinn",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/10/Xyon_Quinn_Pro--0e27e54d2a8e9e83c7f98a39507ae333.png",
        "points": 70,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [],
        "followers": 5000
    },
    {
        "id": "triple-h",
        "name": "Triple H",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/01/TripleH_Pro--56cf96e32ae35b75ff370574dfd29bf0.png",
        "points": 19,
        "cost": 40000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt",
            "raw",
            "smackdown"
        ],
        "popularity": 90,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "active": false,
        "followers": 5000,
        "entranceVideoEmbedId": "FM2WB0AyAjA"
    },
    {
        "id": "shelton-benjamin",
        "name": "Shelton Benjamin",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/03/Shelton_Benjamin_Profile--8a31e6e7435a44738c317fc6f3d75b12.png",
        "points": 75,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [],
        "followers": 5000
    },
    {
        "id": "colt-cabana",
        "name": "Colt Cabana",
        "image": "//static.wixstatic.com/media/ac2041_3b0f83465d304d74970017dc7c03b574~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_3b0f83465d304d74970017dc7c03b574~mv2.jpg",
        "points": 75,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "roh"
        ],
        "popularity": 80,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "drew-gulak",
        "name": "Drew Gulak",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/11/Drew_Gulak_Pro--746e11f2d0128414ae3d22ca04ff7a4a.png",
        "points": 70,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "ivar",
        "name": "Ivar",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Ivar_PROFILE--92a85e7c285c935a5ac45f7ff8a3a677.png",
        "points": 79,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "erik",
        "name": "Erik",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/07/Erik_PROFILE--c4dbc71f8dfa2f555bc7d6a2694694c3.png",
        "points": 78,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "active": false,
        "damage": 100,
        "followers": 5000
    },
    {
        "id": "valhalla",
        "name": "Valhalla",
        "gender": "FEMALE",
        "points": 63,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Valhalla_PROFILE--d6b8a9a0d2b52856210cd1e3786d121f.png"
    },
    {
        "id": "nikki-cross",
        "name": "Nikki Cross",
        "gender": "FEMALE",
        "points": 62,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Nikki_Cross_PROFILE--c332352d1c0e25d2e9589d85fcb1ce28.png"
    },
    {
        "id": "carmella",
        "name": "Carmella",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/Carmella_02062023PM_00036_profile--dc68050b52124929c2c3955bd4012282.png",
        "gender": "FEMALE",
        "points": 74,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "jade-cargill",
        "name": "Jade Cargill",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/02/JadeCargill_01282024RF_2813_Ntwk_Profile--aa21f2932fe9bf08034c3a8f54944f77.png",
        "gender": "FEMALE",
        "points": 90,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "smackdown"
        ],
        "followers": 500000,
        "popularity": 79,
        "charisma": 100,
        "stamina": 100,
        "morale": 100,
        "damage": 0,
        "active": true
    },
    {
        "id": "nia-jax",
        "name": "Nia Jax",
        "role": ROLES.GIANT,
        "goalIds": [
            "womens-world-championship"
        ],
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/10/Nia_Jax_PROFILE--86d11bb35d78bfede870e62197f5b4cf.png",
        "gender": "FEMALE",
        "points": 80,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "smackdown"
        ],
        "popularity": 10,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "montez-ford",
        "name": "Montez Ford",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/06/MontezFord_Pro--aea9c365d90d0d582cbc9b5d12d6438a.png",
        "points": 76,
        "cost": 4000,
        "alignment": "GOOD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "akira-tozawa",
        "name": "Akira Tozawa",
        "role": ROLES.CRUISER,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Akira_Tozawa_PROFILE--b20d59d74b58208c55707717d20669cc.png",
        "points": 65,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "omos",
        "name": "Omos",
        "role": ROLES.GIANT,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/09/004_OMOS_05032021jg_0093--b7339ffa67e25dc1769dc685a56d3a76.png",
        "points": 76,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [],
        "followers": 5000
    },
    {
        "id": "sonny-kiss",
        "name": "Sonny Kiss",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "mickie-james",
        "name": "Mickie James",
        "gender": "FEMALE",
        "points": 75,
        "cost": 10000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "followers": 5000,
        "damage": 50,
        "active": false,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/12/Mickie_James_Pro--4dbd336b4cf4385f07b81dd25703c579.png"
    },
    {
        "id": "dijak",
        "role": ROLES.GIANT,
        "name": "Dijak",
        "points": 77,
        "cost": 5000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "popularity": 50,
        "charisma": 50,
        "stamina": 50,
        "morale": 80,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2022/12/Dijak_PROFILE--b3c6f440540a1334ce31184ca68c3fc4.png"
    },
    {
        "id": "liv-morgan",
        "name": "Liv Morgan",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/06/Raquel_LIV__04172023ca_0017_profile--cde65e4fc5940aa282bca452aab96a40.png",
        "gender": "FEMALE",
        "points": 85,
        "cost": 40000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "goalIds": [
            "womens-world-championship"
        ],
        "followers": 5000
    },
    {
        "id": "jimmy-uso",
        "name": "Jimmy Uso",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/03/Jimmy_Uso_Pro--d2824230adf829eb15c347840df00c92.png",
        "points": 84,
        "cost": 60000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "entranceVideoEmbedId": "tscAN8W0QgU"
    },
    {
        "id": "qtmarshall",
        "name": "QT Marshall",
        "points": 75,
        "cost": 10000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/815952_3a3328b0e3ac4c5db4b5547d1b3433b6~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_3a3328b0e3ac4c5db4b5547d1b3433b6~mv2.jpg"
    },
    {
        "id": "bea-priestly",
        "name": "Bea Priestley",
        "gender": "FEMALE",
        "points": 75,
        "cost": 5000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "thunder-rosa",
        "name": "Thunder Rosa",
        "gender": "FEMALE",
        "points": 85,
        "cost": 30000,
        "brandIds": [
            "collision"
        ],
        "alignment": "NEUTRAL",
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_9aa29a092d9b4a929551334863132b2b~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_9aa29a092d9b4a929551334863132b2b~mv2.jpg"
    },
    {
        "id": "dominik-mysterio",
        "name": "Dominik Mysterio",
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2024/03/Mysterio_07252023mp_142_Profile--e6c9dde99d9bf8c8664e67d6c736e6d2.png",
        "points": 83,
        "cost": 15000,
        "alignment": "BAD",
        "role": ROLES.CRUISER,
        "damage": 80,
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "gran-metalik",
        "name": "Gran Metalik",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Gran_Metalik_Pro--43efed9d4f5efee095abdaa85ba9d4c3.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "cedric-alexander",
        "name": "Cedric Alexander",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/06/Cedric_Alexander_Profile--f918374d31d5f4d91ca48a65f2337f89.png",
        "points": 70,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "smackdown"
        ],
        "followers": 5000
    },
    {
        "id": "maryse",
        "name": "Maryse",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Maryse_Pro--d7ef6d197c970b03854bb995ac3da332.png",
        "gender": "FEMALE",
        "points": 79,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "dana-brooke",
        "name": "Dana Brooke",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/07/DanaBrooke_04102021MM_099001_Profile--25f60053575a6e43dba4ba7b5dd6b4f3.png",
        "gender": "FEMALE",
        "points": 70,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000
    },
    {
        "id": "maxxine-dupri",
        "name": "MAXXINE DUPRI",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/MMM_07222022DG_6927_profile--60806ee1f560659739b136d4cae28a46.png",
        "gender": "FEMALE",
        "points": 64,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "la-knight",
        "name": "LA Knight",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/LA_Knight_PROFILE--a171170c728eef7fe7f0f21629d0eb7f.png",
        "points": 88,
        "cost": 65000,
        "alignment": "GOOD",
        ...sd,
        "popularity": 95,
        "charisma": 90,
        "stamina": 60,
        "morale": 80,
        "followers": 500000
    },
    {
        "id": "dakota-kai",
        "name": "Dakota Kai",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/08/Dakota_08082022MM_15097_profile--9b0c56a8a4e4ade67cc1c27ac5612904.png",
        "gender": "FEMALE",
        "points": 78,
        "cost": 50000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000
    },
    {
        "id": "alex-reynolds",
        "name": "Alex Reynolds",
        "image": "//vignette.wikia.nocookie.net/prowrestling/images/c/cd/ALEX_REYNOLDS_-_NYCWRESTLING8d47db.png/revision/latest?cb=20180517205925",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "brandoncutler",
        "name": "Brandon Cutler",
        "image": "//static.wixstatic.com/media/ac2041_fd7715d4226442e6b4665f40468d1224~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_fd7715d4226442e6b4665f40468d1224~mv2.jpg",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "johnsilver",
        "name": "John Silver",
        "image": "//static.wixstatic.com/media/ac2041_e277646eedc44409ace62ac8b42cb6d7~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_e277646eedc44409ace62ac8b42cb6d7~mv2.jpg",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "peteravalon",
        "name": "Peter Avalon",
        "image": "//www.shopaew.com/images/thumb-5d7923c9c5432.jpg",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "shane-mcmahon",
        "name": "Shane McMahon",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/01/Shane_McMahon_Profile--4ac449d384a48dbf2eccf12d3fbd64ea.png",
        "points": 70,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "hall-of-fame"
        ],
        "followers": 5000,
        "damage": 70,
        "active": false
    },
    {
        "id": "tony-khan",
        "name": "Tony Khan",
        "image": "//static.clubs.nfl.com/image/private/t_editorial_landscape_12_desktop/jaguars/jt26ywmaiham3uxem0ij",
        "points": 1,
        "cost": 0,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "eric-bischoff",
        "name": "Eric Bischoff",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/03/sBISCH_00001997_0001_Profile--54526b070e6c973cd60e77e5627615f2.png",
        "points": 1,
        "cost": 0,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "pat-mcafee",
        "name": "Pat McAfee",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/07/PAT_04162021ej_00018_PatMcAfee_Profile--e71dee19114d2e3d5054ce7f338ebab5.png",
        "points": 70,
        "cost": 0,
        "alignment": "GOOD",
        ...sd,
        "popularity": 90,
        "charisma": 90,
        "stamina": 90,
        "morale": 90,
        "followers": 500000
    },
    {
        "id": "veer",
        "name": "Veer",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/04/Veer_PROFILE--1ea6c57e591c872d16d87de1f50cce0d.png",
        "points": 75,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "r-truth",
        "name": "R-Truth",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/10/R_Truth_pro--081bf34d64e30eeb5f23dd1523556043.png",
        "points": 70,
        "cost": 50000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "jinder-mahal",
        "name": "Jinder Mahal",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/JinderMahal_01242023AK_00703_Profile--4e1bbf542abd0dab0ac9d6b24392ecaf.png",
        "points": 74,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "popularity": 20,
        "charisma": 20,
        "stamina": 40,
        "damage": 15,
        "followers": 5000
    },
    {
        "id": "william-regal",
        "name": "William Regal",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/William_Regal_pro.png",
        "points": 20,
        "cost": 5000,
        "active": false,
        "brandIds": [
            "nxt"
        ],
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "vickie-guerrero",
        "name": "Vickie Guerrero",
        "image": "//www.wwe.com/f/styles/wwe_large/public/2016/03/Vickie_Guerrero_bio--0a44827a757ab9c396a3840685ae44dd.jpg",
        "gender": "FEMALE",
        "points": 20,
        "cost": 5000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "nikki-bella",
        "name": "Nikki Bella",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Nikki_Bella_Pro--c86b4324c646f9db7528a996ada0fbc1.png",
        "gender": "FEMALE",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "katana-chance",
        "name": "Katana Chance",
        "points": 74,
        "gender": "FEMALE",
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/Kacy_Catanzaro_Pro--1b3c0edbf502527429d52f62f2808952.png"
    },
    {
        "id": "kayden-carter",
        "name": "Kayden Carter",
        "gender": "FEMALE",
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2023/02/Kayden_Carter_Pro--7a055244954f6cfaa84d0a98538b6b76.png"
    },
    {
        "id": "elton-prince",
        "name": "Elton Prince",
        "points": 76,
        "cost": 50000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/06/Pretty_Deadly_04122022pm_2422_Profile--e7030a5d128d8517f185ada4d3e19f3e.png"
    },
    {
        "id": "kit-wilson",
        "name": "Kit Wilson",
        "points": 76,
        "cost": 50000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/06/Pretty_Deadly_04122022pm_2342_Profile--97c28b0967e3baf645483da2421e8f21.png"
    },
    {
        "id": "odyssey-jones",
        "name": "Odyssey Jones",
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/08/JONES_03112021CA_06747-2_Odyssey_Jones_Profile--665edb9f3cd5a99a54de3d15c9693237.png"
    },
    {
        "id": "riddick-moss",
        "name": "Riddick Moss",
        "alignment": "NEUTRAL",
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/06/Madcap_Moss_Profile--caabfe7460a65fbb65e5184201c75bda.png"
    },
    {
        "id": "brie-bella",
        "name": "Brie Bella",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Brie_Bella_Pro--a1bc869798010ba227c65a61608f977c.png",
        "gender": "FEMALE",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "followers": 5000
    },
    {
        "id": "vince-mcmahon",
        "name": "Vince McMahon",
        "image": "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2022/04/283_WM38_04032022RF_18218--fbd3fe75b2d22971d2eb069f27a09c00.jpg",
        "points": 1,
        "cost": 100000,
        "alignment": "NEUTRAL",
        "followers": 5000,
        "active": false
    },
    {
        "id": "Axiom",
        "name": "Axiom",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/10/Axiom_10112022pm_5701_profile--4944b3e7536ced15fba6c6d8a4e6f6b8.png",
        "points": 73,
        "cost": 4000,
        "alignment": "GOOD",
        "followers": 5000,
        "active": false
    },
    {
        "id": "adam-pearce",
        "name": "Adam Pearce",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2021/04/Superstar_Adam_Pearce--4c1dc7012177b18eed5f4e03521dab11.png",
        "points": 19,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "booker-t",
        "name": "Booker T",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Booker_T_Pro--f67b8c25d0e4df9e9bcbf02a379eaca2.png",
        "points": 19,
        "cost": 20000,
        "alignment": "GOOD",
        "brandIds": [
            "nxt"
        ],
        "followers": 500000,
        "active": false
    },
    {
        "id": "mike-rome",
        "name": "Mike Rome",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Mike_Rome_Pro--e1811898c1bd401dff9139dc659c4097.png",
        "points": 1,
        "cost": 4000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "jerry-lawler",
        "name": "Jerry Lawler",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Jerry_Lawler_Pro--c7ca9e02467d40af4cd2c31d93a8db43.png",
        "points": 20,
        "cost": 5000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000
    },
    {
        "id": "paul-heyman",
        "name": "Paul Heyman",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Paul_Heyman_Pro--b72f01bd7b26bd63671f44e4ef295b68.png",
        "points": 1,
        "cost": 75000,
        "alignment": "BAD",
        ...sd,
        "popularity": 60,
        "charisma": 90,
        "stamina": 50,
        "morale": 90,
        "followers": 5000,
        "active": false
    },
    {
        "id": "kayla-braxton",
        "name": "Kayla Braxton",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/09/Kayla_Braxton_Pro--767bcbd52701fabcd8976d3011bb6e71.png",
        "gender": "FEMALE",
        "points": 20,
        "cost": 5000,
        "alignment": "GOOD",
        ...sd,
        "active": false,
        "followers": 5000
    },
    {
        "id": "corey-graves",
        "name": "Corey Graves",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Corey_Graves_Pro--fab149c2bfbf286ba1577b275b0d9ffa.png",
        "points": 20,
        "cost": 5000,
        "alignment": "BAD",
        "brandIds": [
            "raw"
        ],
        "active": false,
        "followers": 5000
    },
    {
        "id": "michael-cole",
        "name": "Michael Cole",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/01/Michael_Cole_Pro--33d7aea41324f584cc287a616fc4c0a1.png",
        "points": 20,
        "cost": 5000,
        "alignment": "GOOD",
        ...sd,
        "popularity": 50,
        "charisma": 50,
        "stamina": 50,
        "damage": 90,
        "active": false,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "byron-saxton",
        "name": "Byron Saxton",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Byron_Saxton_Pro--180bf17f4a34b7d9123274d88a2d1a3f.png",
        "points": 20,
        "cost": 5000,
        "alignment": "GOOD",
        "brandIds": [
            "raw"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "robert-stone",
        "name": "Mr. Stone",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2020/09/Robert_Stone_Pro--3ca5fd1c330319b7d5a7915544a6f5a9.png",
        "points": 1,
        "cost": 5000,
        "alignment": "BAD",
        "brandIds": [
            "nxt"
        ],
        "followers": 5000,
        "active": false
    },
    {
        "id": "karl-anderson",
        "name": "Karl Anderson",
        "points": 72,
        "cost": 55000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Karl_Anderson_PROFILE--2fc07deccad7683373a11998fc018a18.png"
    },
    {
        "id": "luke-gallows",
        "name": "Luke Gallows",
        "points": 73,
        "cost": 55000,
        "alignment": "BAD",
        ...sd,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2022/11/Luke_Gallows_PROFILE--dd0fd4629a7cade6370404148ec2fbae.png"
    },
    {
        "id": "aaron-henare",
        "name": "Aaron Henare",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/henare_20210404_3.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "alex-coughlin",
        "name": "Alex Coughlin",
        "image": "//www.njpw1972.com/wp-content/uploads/2018/10/AlexCoughlin_20220518_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "alex-zayne",
        "name": "Alex Zayne",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/11/AlexZayne_20220524_6-1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "bad-dude-tito",
        "name": "Bad Dude Tito",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/11/BadDudeTito_220514_@AEW_2-2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "bad-luck-fale",
        "name": "Bad Luck Fale",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/fale_20210107_3-1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "barrett-brown",
        "name": "Barrett Brown",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/11/20191114_BarretBrown@free_1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "bateman",
        "name": "BATEMAN",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/01/TylerBateman_20201113_02.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "blake-christian",
        "name": "Blake Christian",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/08/BlakeChristian_20201113_01.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "brodyking",
        "name": "Brody King",
        "image": "//static.wixstatic.com/media/815952_89814c8c343841a2ba8a088f22381df4~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_89814c8c343841a2ba8a088f22381df4~mv2.jpg",
        "points": 90,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "bushi",
        "name": "BUSHI",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/BUSHI_20220513_1-1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "chase-owens",
        "name": "Chase Owens",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/Chase_20210730_2.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "chris-bey",
        "name": "Chris Bey",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/11/ChrisBey_20210831@TNA.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "chris-dickinson",
        "name": "Chris Dickinson",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/01/chrisdickinson2.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "claudio-castagnoli",
        "name": "Claudio Castagnoli",
        "image": "//static.wixstatic.com/media/815952_87033d085e3d4d439a1478e5d247e181~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_87033d085e3d4d439a1478e5d247e181~mv2.jpg",
        "points": 85,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "popularity": 40,
        "charisma": 20,
        "stamina": 50,
        "morale": 50,
        "followers": 5000
    },
    {
        "id": "danielgarcia",
        "name": "Daniel Garcia",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_ba4daaaaf8a64aeab2c6e64a4a07dfd5~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_ba4daaaaf8a64aeab2c6e64a4a07dfd5~mv2.jpg"
    },
    {
        "id": "danny-limelight",
        "name": "Danny Limelight",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/07/DannyLimelight_20210511_02-1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "david-finlay",
        "name": "David Finlay",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/Finlay_20220514_@AEW_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "dick-togo",
        "name": "Dick Togo",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/03/DickTogo_20200720_4-1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "douki",
        "name": "DOUKI",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/05/DOUKI_20210107_3.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "el-desperado",
        "name": "El Desperado",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/Despe_20210311_2.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "el-phantasmo",
        "name": "El Phantasmo",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/04/ElPhantasmo20210107_5.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "evil",
        "name": "EVIL",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/EVIL_20211515_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "francesco-akira",
        "name": "Francesco Akira",
        "image": "//www.njpw1972.com/wp-content/uploads/2022/05/FrancescoAkira_20220524_4.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "fred-rosser",
        "name": "Fred Rosser",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/09/fred.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "gabriel-kidd",
        "name": "Gabriel Kidd",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/01/GabrielKidd_20210413_2.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "gedo",
        "name": "Gedo",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/gedo_20190718_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "great-o-khan",
        "name": "Great-O-Khan",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/01/Okhan_20201016_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "hikuleo",
        "name": "Hikuleo",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/09/HIKULEO_20190308_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "hiromu-takahashi",
        "name": "Hiromu Takahashi",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/hiromu_20220301_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "hirooki-goto",
        "name": "Hirooki Goto",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/goto_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "hiroshi-tanahashi",
        "name": "Hiroshi Tanahashi",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/tanahashi_20220121_2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000,
        "damage": 50,
        "active": false
    },
    {
        "id": "hiroyoshi-tenzan",
        "name": "Hiroyoshi Tenzan",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/tenzan_20190617_4-1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "jado",
        "name": "Jado",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/jado_20220705_2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "jay-white",
        "name": "Jay White",
        "image": "//static.wixstatic.com/media/ac2041_124dbe3de6cb4da3a964fd2d9445de9e~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_124dbe3de6cb4da3a964fd2d9445de9e~mv2.jpg",
        "points": 90,
        "goalIds": [
            "a-mens"
        ],
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "mark-briscoe",
        "name": "Mark Briscoe",
        "points": 85,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "roh"
        ],
        "popularity": 80,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 50000
    },
    {
        "id": "jay-briscoe",
        "name": "Jay Briscoe",
        "points": 80,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "roh"
        ],
        "popularity": 80,
        "charisma": 50,
        "stamina": 50,
        "morale": 50,
        "followers": 50000
    },
    {
        "id": "andrade",
        "name": "Andrade",
        "points": 85,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "smackdown"
        ],
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_s/public/all/2019/12/Andrade_Pro--e74f5297207b805ca50603ab14288466.png"
    },
    {
        "id": "athena",
        "image": "//static.wixstatic.com/media/ac2041_0ab4940a9b564141b89abb27503de067~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_0ab4940a9b564141b89abb27503de067~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "roh"
        ],
        "followers": 50000
    },
    {
        "id": "coltongunn",
        "name": "Colton Gunn",
        "image": "//static.wixstatic.com/media/815952_d036893b42a2433a8397bd34f2c34caa~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_d036893b42a2433a8397bd34f2c34caa~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "austingunn",
        "name": "Austin Gunn",
        "image": "//static.wixstatic.com/media/ac2041_3d59aee677e44ec5bd35d23be27fcc4c~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_3d59aee677e44ec5bd35d23be27fcc4c~mv2.jpg",
        "points": 80,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 50000
    },
    {
        "id": "billy-gunn",
        "name": "Billy Gunn",
        "image": "//static.wixstatic.com/media/815952_12ebc43e272647b89ae84c77416c3b34~mv2.jpg/v1/fill/w_380,h_380,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_12ebc43e272647b89ae84c77416c3b34~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000
    },
    {
        "id": "jonah",
        "name": "JONAH",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/11/JONAH_20220514_@AEW_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "jonathan-gresham",
        "name": "Jonathan Gresham",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/01/JonathanGresham_20190222_4.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "jorel-nelson",
        "name": "Jorel Nelson",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/05/Jorel_20210315_01.gif",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "jr-kratos",
        "name": "JR Kratos",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/11/JR-Kratos_20210601_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "juice-robinson",
        "name": "Juice Robinson",
        "image": "//static.wixstatic.com/media/ac2041_85f8210ba5104043a30d3d4901053656~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_85f8210ba5104043a30d3d4901053656~mv2.jpg",
        "points": 85,
        "cost": 55000,
        "alignment": "BAD",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "popularity": 50,
        "charisma": 90,
        "stamina": 90,
        "morale": 90,
        "followers": 500000
    },
    {
        "id": "karl-fredericks",
        "name": "Karl Fredericks",
        "image": "//www.njpw1972.com/wp-content/uploads/2018/10/KarlFredericks_20210930_4.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "katsuyori-shibata",
        "name": "Katsuyori Shibata",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/shibata_01_01-1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kazuchika-okada",
        "name": "Kazuchika Okada",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/okada_20220131_11.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kenta",
        "name": "KENTA",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2017/06/Hideo_Itami_pro--27e5511765e487325f9c5d1f40d61fab.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kevin-knight",
        "name": "Kevin Knight",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/12/KevinKnight_20201113_01.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kosei-fujita",
        "name": "Kosei Fujita",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/08/FujitaKosei_20211223_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kota-ibushi",
        "name": "Kota Ibushi",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/03/ibushi_20200907_4-copy.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kyle-fletcher",
        "name": "Kyle Fletcher",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/08/KyleFletcherAussie-Open_20190821@ROH.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "kyle-oreilly",
        "name": "Kyle O Reilly",
        "image": "//static.wixstatic.com/media/ac2041_7919d29a2d39420292cd983bf6859264~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_7919d29a2d39420292cd983bf6859264~mv2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "damage": 60,
        "active": false
    },
    {
        "id": "rush",
        "name": "Rush",
        "image": "//static.wixstatic.com/media/ac2041_ed96d45bbb4c4871b224cce17b757a60~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_ed96d45bbb4c4871b224cce17b757a60~mv2.jpg",
        "points": 85,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "collision"
        ],
        "followers": 5000
    },
    {
        "id": "lio-rush",
        "name": "Lio Rush",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Superstar_Lio_Rush_Profile--1a115498c62e88305bb516e20cfd951e.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "mark-davis",
        "name": "Mark Davis",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/08/MarkDavisAussie-Open_20190821@ROH.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "mascara-dorada",
        "name": "Mascara Dorada",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/03/MascaraDorada_20220217_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "master-wato",
        "name": "Master Wato",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/07/wato_20210901_3.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "mikey-nicholls",
        "name": "Mikey Nicholls",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/02/MikeyNicholls_20190308_5-1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "minoru-suzuki",
        "name": "Minoru Suzuki",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/suzuki_20200907_2.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "misterioso",
        "name": "Misterioso",
        "image": "//www.njpw1972.com/wp-content/uploads/2019/11/20191114_Misterioso@free_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "ren-narita",
        "name": "Ren Narita",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/Narita_20210930_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "robbie-eagles",
        "name": "Robbie Eagles",
        "image": "//www.njpw1972.com/wp-content/uploads/2018/10/RobbieEagles_20201120_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "rocky-romero",
        "name": "Rocky Romero",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/rocky_20210830_4.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "royce-isaacs",
        "name": "Royce Isaacs",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/05/RoyceIsaacs_20220514_@AEW_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "ryohei-oiwa",
        "name": "Ryohei Oiwa",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/08/OiwaRyohei_20211223_4.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "dragon-lee",
        "name": "Dragon Lee",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/04/DragonLee_PROFILE--1f4a6234a174e11bd6c26fda0292e73f.png",
        "points": 82,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "smackdown",
            "nxt"
        ],
        "popularity": 70,
        "charisma": 50,
        "stamina": 100,
        "morale": 70,
        "followers": 100000
    },
    {
        "id": "ryusuke-taguchi",
        "name": "Ryusuke Taguchi",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/taguchi_20210901_3.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "sanada",
        "name": "SANADA",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/sanada_20220120_6.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "satoshi-kojima",
        "name": "Satoshi Kojima",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/kojima_20210303_1.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "shane-haste",
        "name": "Shane Haste",
        "image": "//www.njpw1972.com/wp-content/uploads/2022/03/ShaneHaste_20220217_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "shingo-takagi",
        "name": "Shingo Takagi",
        "image": "//www.njpw1972.com/wp-content/uploads/2018/10/takagi_20220318_3.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "sho",
        "name": "SHO",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/09/sho_20210921_05.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "shota-umino",
        "name": "Shota Umino",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/03/umino_20190811_5-2.png",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "s-w-3-rve",
        "name": "SW3RVE",
        "image": "//www.njpw1972.com/wp-content/uploads/2022/02/Sw3rve_202201_1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "taichi",
        "name": "Taichi",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/taichi_20210730_2.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "taiji-ishimori",
        "name": "Taiji Ishimori",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/04/ishimori_20220121_5.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "taka-michinoku",
        "name": "TAKA Michinoku",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/TAKA_20211130_4.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tama-tonga",
        "name": "Tama Tonga",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/tama_20220404_1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tanga-loa",
        "name": "Tanga Loa",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/loa_20220409_2.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tetsuya-naito",
        "name": "Tetsuya Naito",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/naito_20220121_suit_5.jpg",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "the-dkc",
        "name": "The DKC",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/07/DKC_20210520_01.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tiger-mask",
        "name": "Tiger Mask",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Tiger_Mask_pro.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tit-n",
        "name": "Tit\xe1n",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/06/Titan_20220421_4※\xa9CMLL表記必要.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tjp",
        "name": "TJP",
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2018/08/TJP_Pro--84993c4e57e4bbeca72df28caaa481ec.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "togi-makabe",
        "name": "Togi Makabe",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/makabe_20211130_5.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tom-lawlor",
        "name": "Tom Lawlor",
        "image": "//www.njpw1972.com/wp-content/uploads/2020/07/TomLawlor_20220514_@AEW_1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tomoaki-honma",
        "name": "Tomoaki Honma",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/honma_20220318_4.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "tomohiro-ishii",
        "name": "Tomohiro Ishii",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/ishii_20170616_02-1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "toru-yano",
        "name": "Toru Yano",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/yano_20190616_2-1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "volador-jr",
        "name": "Volador Jr.",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/03/VoladorJr_20191016_3-1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "wheeler-yuta",
        "name": "Wheeler Yuta",
        "image": "//static.wixstatic.com/media/ac2041_0cd5183481a34bb7aaa509ea5deca5e4~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_0cd5183481a34bb7aaa509ea5deca5e4~mv2.jpg",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite",
            "roh"
        ],
        "followers": 5000
    },
    {
        "id": "will-ospreay",
        "name": "Will Ospreay",
        "image": "//static.wixstatic.com/media/815952_12a7163ea94a4cb7b997927575837785~mv2.jpg/v1/fill/w_380,h_380,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/815952_12a7163ea94a4cb7b997927575837785~mv2.jpg",
        "points": 90,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw",
            "dynamite"
        ],
        "popularity": 70,
        "charisma": 580,
        "stamina": 80,
        "morale": 80,
        "followers": 599000,
        "damage": 40,
        "active": true
    },
    {
        "id": "danhausen",
        "name": "Danhausen",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "dynamite"
        ],
        "followers": 5000,
        "image": "//static.wixstatic.com/media/ac2041_87a8cb132e7d4621add82b60ea2b2c8d~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_87a8cb132e7d4621add82b60ea2b2c8d~mv2.jpg"
    },
    {
        "id": "yoh",
        "name": "YOH",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/09/YOH_20211129_3.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yoshi-hashi",
        "name": "YOSHI-HASHI",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/YoshiHashi_20211026_2.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yoshinobu-kanemaru",
        "name": "Yoshinobu Kanemaru",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/kanemaru_20190423_3-1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yota-tsuji",
        "name": "Yota Tsuji",
        "image": "//www.njpw1972.com/wp-content/uploads/2018/03/tsuji_20200803_4.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yuji-nagata",
        "name": "Yuji Nagata",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/nagata_20220526_3.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yujiro-takahashi",
        "name": "Yujiro Takahashi",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/yujiro_20210329_4-1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yuto-nakashima",
        "name": "Yuto Nakashima",
        "image": "//www.njpw1972.com/wp-content/uploads/2021/02/NakashimaYuto_20211222_2.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "yuya-uemura",
        "name": "Yuya Uemura",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/Uemura_20210930_2.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "zack-sabre-jr",
        "name": "Zack Sabre Jr.",
        "image": "//www.njpw1972.com/wp-content/uploads/2017/02/zack_20211026_1.png",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "njpw"
        ],
        "followers": 5000
    },
    {
        "id": "rob-van-dam",
        "name": "Rob Van Dam",
        "points": 90,
        "cost": 75000,
        "alignment": "GOOD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 90,
        "charisma": 85,
        "stamina": 85,
        "morale": 80,
        "followers": 9500,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Rob_Van_Dam_pro.png"
    },
    {
        "id": "tommy-dreamer",
        "name": "Tommy Dreamer",
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/tommy-dreamer-hs.jpg",
        "points": 90,
        "cost": 70000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 85,
        "followers": 8500
    },
    {
        "id": "sabu",
        "name": "Sabu",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 90,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Sabu_pro.png"
    },
    {
        "id": "taz",
        "name": "Tazz",
        "points": 95,
        "cost": 75000,
        "alignment": "GOOD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 85,
        "followers": 9000,
        "image": "//www.shopaew.com/images/thumb-5f29d9a73bab9.jpg"
    },
    {
        "id": "francine",
        "name": "Francine",
        "gender": "FEMALE",
        "points": 20,
        "cost": 5000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 60,
        "morale": 75,
        "followers": 7500,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Francine_pro.png"
    },
    {
        "id": "jerry-lynn",
        "name": "Jerry Lynn",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "active": false,
        "followers": 7500
    },
    {
        "id": "raven",
        "name": "Raven",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Raven_pro.png"
    },
    {
        "id": "the-sandman",
        "name": "The Sandman",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 85,
        "morale": 70,
        "followers": 7500
    },
    {
        "id": "new-jack",
        "name": "New Jack",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 70,
        "followers": 8000
    },
    {
        "id": "sabu",
        "name": "Sabu",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 90,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Sabu_pro.png"
    },
    {
        "id": "jerry-lynn",
        "name": "Jerry Lynn",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7500
    },
    {
        "id": "raven",
        "name": "Raven",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Raven_pro.png"
    },
    {
        "id": "the-sandman",
        "name": "The Sandman",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 85,
        "morale": 70,
        "followers": 7500
    },
    {
        "id": "new-jack",
        "name": "New Jack",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 70,
        "followers": 8000
    },
    {
        "id": "sabu",
        "name": "Sabu",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 90,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Sabu_pro.png"
    },
    {
        "id": "the-dudley-boyz",
        "name": "The Dudley Boyz",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 70,
        "followers": 9000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Bubba_Ray_Dudley_pro.png"
    },
    {
        "id": "tajiri",
        "name": "Tajiri",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Tajiri_pro.png"
    },
    {
        "id": "justin-credible",
        "name": "Justin Credible",
        "points": 70,
        "cost": 50000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 80,
        "morale": 75,
        "followers": 7500
    },
    {
        "id": "the-blue-meanie",
        "name": "The Blue Meanie",
        "points": 65,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 70,
        "charisma": 60,
        "stamina": 70,
        "morale": 65,
        "followers": 5000
    },
    {
        "id": "shane-douglas",
        "name": "Shane Douglas",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/2016/03/Shane_Douglas_pro--415c66dc1e40289b26cb8a9aee52f14b.png"
    },
    {
        "id": "mikey-whipwreck",
        "name": "Mikey Whipwreck",
        "points": 60,
        "cost": 3000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 70,
        "charisma": 65,
        "stamina": 70,
        "morale": 65,
        "followers": 5500
    },
    {
        "id": "francine",
        "name": "Francine",
        "gender": "FEMALE",
        "points": 20,
        "cost": 5000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 60,
        "morale": 75,
        "followers": 7500,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Francine_pro.png"
    },
    {
        "id": "todd-gordon",
        "name": "Todd Gordon",
        "points": 20,
        "cost": 5000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 60,
        "morale": 75,
        "followers": 7000
    },
    {
        "id": "joey-styles",
        "name": "Joey Styles",
        "points": 20,
        "cost": 5000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 60,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/2016/03/Joey_Styles_pro--15cdbf3a6ec55b3ba32f06257f4cb7f2.png"
    },
    {
        "id": "al-snow",
        "name": "Al Snow",
        "points": 65,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 70,
        "morale": 70,
        "followers": 6000
    },
    {
        "id": "new-jack",
        "name": "New Jack",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 70,
        "followers": 8000
    },
    {
        "id": "lance-storm",
        "name": "Lance Storm",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 80,
        "morale": 75,
        "followers": 7000
    },
    {
        "id": "raven",
        "name": "Raven",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Raven_pro.png"
    },
    {
        "id": "rhino",
        "name": "Rhino",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "ecw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 75,
        "followers": 8500
    },
    {
        "id": "hulk-hogan",
        "name": "Hulk Hogan",
        "points": 99,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 90,
        "charisma": 90,
        "stamina": 80,
        "morale": 80,
        "followers": 10000,
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Hulk_Hogan_Bio.jpg"
    },
    {
        "id": "ric-flair",
        "name": "Ric Flair",
        "points": 99,
        "cost": 100000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 95,
        "stamina": 80,
        "morale": 85,
        "followers": 9000,
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Ric_Flair_bio.jpg"
    },
    {
        "id": "sting",
        "name": "Sting",
        "points": 95,
        "cost": 75000,
        "alignment": "GOOD",
        "brandIds": [
            "dynamite"
        ],
        "popularity": 90,
        "charisma": 85,
        "stamina": 90,
        "morale": 85,
        "followers": 80000,
        "image": "//static.wixstatic.com/media/ac2041_4251a9c0b92a4d0581f50ad9d7cead0f~mv2.jpg/v1/fill/w_190,h_190,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/ac2041_4251a9c0b92a4d0581f50ad9d7cead0f~mv2.jpg"
    },
    {
        "id": "randy-savage",
        "name": "Randy Savage",
        "points": 95,
        "cost": 75000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 90,
        "stamina": 80,
        "morale": 80,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Randy_Savage_bio.jpg"
    },
    {
        "id": "kevin-nash",
        "name": "Kevin Nash",
        "points": 95,
        "cost": 75000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 75,
        "followers": 7500
    },
    {
        "id": "booker-t",
        "name": "Booker T",
        "points": 90,
        "cost": 70000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 85,
        "morale": 80,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/12/Booker_T_Pro--f67b8c25d0e4df9e9bcbf02a379eaca2.png"
    },
    {
        "id": "eddie-guerrero",
        "name": "Eddie Guerrero",
        "points": 90,
        "cost": 70000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 85,
        "stamina": 80,
        "morale": 80,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Eddie_Guerrero_bio.png"
    },
    {
        "id": "chris-benoit",
        "name": "Chris Benoit",
        "points": 90,
        "cost": 70000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 90,
        "morale": 80,
        "followers": 8000
    },
    {
        "id": "diamond-dallas-page",
        "name": "Diamond Dallas Page",
        "points": 90,
        "cost": 70000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 75,
        "followers": 7500
    },
    {
        "id": "scott-hall",
        "name": "Scott Hall",
        "points": 85,
        "cost": 65000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 7000
    },
    {
        "id": "kevin-sullivan",
        "name": "Kevin Sullivan",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 60,
        "charisma": 60,
        "stamina": 70,
        "morale": 60,
        "followers": 5000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Kevin_Sullivan_pro.png"
    },
    {
        "id": "big-van-vader",
        "name": "Big Van Vader",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 90,
        "morale": 80,
        "followers": 8000
    },
    {
        "id": "ricky-steamboat",
        "name": "Ricky Steamboat",
        "points": 95,
        "cost": 75000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 85,
        "stamina": 85,
        "morale": 85,
        "followers": 8000
    },
    {
        "id": "lex-luger",
        "name": "Lex Luger",
        "points": 90,
        "cost": 70000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 85,
        "morale": 80,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Lex_Luger_pro.png"
    },
    {
        "id": "buff-bagwell",
        "name": "Buff Bagwell",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 60,
        "charisma": 65,
        "stamina": 70,
        "morale": 65,
        "followers": 5000
    },
    {
        "id": "billy-kidman",
        "name": "Billy Kidman",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 7000
    },
    {
        "id": "dean-malenko",
        "name": "Dean Malenko",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 85,
        "morale": 80,
        "followers": 7500,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Dean_Malenko_pro.png"
    },
    {
        "id": "bret-hart",
        "name": "Bret Hart",
        "points": 93,
        "cost": 100000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 85,
        "stamina": 85,
        "morale": 85,
        "followers": 9000,
        "image": "//www.wwe.com/f/styles/wwe_large/public/rd-talent/Bio/Bret_Hart_bio.png"
    },
    {
        "id": "mr-perfect",
        "name": "Mr. Perfect",
        "points": 95,
        "cost": 75000,
        "alignment": "GOOD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 80,
        "followers": 7500
    },
    {
        "id": "sid-vicious",
        "name": "Sid Vicious",
        "points": 95,
        "cost": 75000,
        "alignment": "BAD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 7000
    },
    {
        "id": "juventud-guerrera",
        "name": "Juventud Guerrera",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7000
    },
    {
        "id": "ernest-miller",
        "name": "Ernest Miller",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 80,
        "morale": 75,
        "followers": 6000
    },
    {
        "id": "scotty-riggs",
        "name": "Scotty Riggs",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 70,
        "charisma": 65,
        "stamina": 75,
        "morale": 70,
        "followers": 5000
    },
    {
        "id": "the-cat",
        "name": "The Cat",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 7000
    },
    {
        "id": "lenny-lane",
        "name": "Lenny Lane",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "wcw"
        ],
        "popularity": 60,
        "charisma": 60,
        "stamina": 70,
        "morale": 60,
        "followers": 4500
    },
    {
        "id": "norman-smiley",
        "name": "Norman Smiley",
        "points": 65,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 75,
        "morale": 70,
        "followers": 5500
    },
    {
        "id": "fit-finlay",
        "name": "Fit Finlay",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "wcw"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7000
    },
    {
        "id": "josh-alexander",
        "name": "Josh Alexander",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7000
    },
    {
        "id": "chris-bey",
        "name": "Chris Bey",
        "points": 80,
        "cost": 60000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 6500,
        "image": "//www.njpw1972.com/wp-content/uploads/2020/11/ChrisBey_20210831@TNA.jpg"
    },
    {
        "id": "deonna-purrazzo",
        "name": "Deonna Purrazzo",
        "gender": "FEMALE",
        "points": 80,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 80,
        "morale": 85,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2019/05/Deonna_Purrazzo_Pro--4d1fa4c0a39a66f00bfafb512e8c1d1b.png"
    },
    {
        "id": "sammy-calloway",
        "name": "Sammy Callahan",
        "points": 85,
        "cost": 65000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7500
    },
    {
        "id": "eddie-edwards",
        "name": "Eddie Edwards",
        "points": 85,
        "cost": 65000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7500
    },
    {
        "id": "ace-austin",
        "name": "Ace Austin",
        "points": 80,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 6500
    },
    {
        "id": "jordynne-grace",
        "name": "Jordynne Grace",
        "gender": "FEMALE",
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/JordynneGrace_2024-1.jpg",
        "points": 92,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 80,
        "followers": 7000
    },
    {
        "id": "moose",
        "name": "Moose",
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/Moose_2024-1.jpg",
        "points": 95,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7500
    },
    {
        "id": "rich-swann",
        "name": "Rich Swann",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 80,
        "stamina": 85,
        "morale": 80,
        "followers": 8000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/all/2016/09/Rich_Swann_pro--8074a44da07ab1e7070038fbfb108fe9.png"
    },
    {
        "id": "trey-miguel",
        "name": "Trey Miguel",
        "points": 80,
        "cost": 60000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 80,
        "morale": 75,
        "followers": 6500
    },
    {
        "id": "rohiti-rajus",
        "name": "Rohit Raju",
        "points": 80,
        "cost": 60000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 70,
        "stamina": 80,
        "morale": 75,
        "followers": 6000
    },
    {
        "id": "jake-something",
        "name": "Jake Something",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "popularity": 70,
        "charisma": 65,
        "stamina": 80,
        "morale": 70,
        "followers": 5000
    },
    {
        "id": "kiera-hogan",
        "name": "Kiera Hogan",
        "gender": "FEMALE",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 70,
        "charisma": 70,
        "stamina": 75,
        "morale": 70,
        "followers": 5500
    },
    {
        "id": "sami-callihan",
        "name": "Sami Callihan",
        "points": 70,
        "cost": 50000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 80,
        "charisma": 75,
        "stamina": 85,
        "morale": 80,
        "followers": 7000
    },
    {
        "id": "crazzy-steve",
        "name": "Crazzy Steve",
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/CrazzySteve_2024-1.jpg",
        "points": 85,
        "cost": 4000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "popularity": 60,
        "charisma": 60,
        "stamina": 70,
        "morale": 60,
        "followers": 4500
    },
    {
        "id": "havok",
        "name": "Havok",
        "gender": "FEMALE",
        "points": 65,
        "cost": 4000,
        "alignment": "BAD",
        "brandIds": [
            "tna"
        ],
        "popularity": 60,
        "charisma": 60,
        "stamina": 75,
        "morale": 60,
        "followers": 4500
    },
    {
        "id": "jazz",
        "name": "Jazz",
        "gender": "FEMALE",
        "points": 55,
        "cost": 2000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "popularity": 60,
        "charisma": 50,
        "stamina": 60,
        "morale": 55,
        "followers": 4000,
        "image": "//www.wwe.com/f/styles/talent_champion_lg/public/rd-talent/Profile/Jazz_pro.png"
    },
    {
        "id": "fallah-bahh",
        "name": "Fallah Bahh",
        "points": 60,
        "cost": 3000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "popularity": 60,
        "charisma": 60,
        "stamina": 70,
        "morale": 60,
        "followers": 4500
    },
    {
        "id": "nathan-frazer",
        "name": "Nathan Frazer",
        "brandIds": [
            "nxt"
        ],
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2021/10/NathanFrazer_Profile--24efa1b22feef77c17325086e111cbd3.png",
        "points": 75
    },
    {
        "id": "fallon-henly",
        "name": "Fallon Henly",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/04/Fallon_Henley_PROFILE--4a0b60f28590ff75dcba841fad89a7cc.png",
        "brandIds": [
            "nxt"
        ],
        "gender": "FEMALE",
        "points": 75
    },
    {
        "id": "josh-briggs",
        "name": "Josh Briggs",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2021/10/JoshBriggs_Profile--93934898b2d4a420e9982d18ba807cbf.png",
        "brandIds": [
            "nxt"
        ],
        "points": 75
    },
    {
        "id": "kelani-jordan",
        "name": "Kelani Kordan",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/07/Kelani_Jordan_PROFILE--4d8ce2c5c074bbf64c5666bc294d3a88.png",
        "brandIds": [
            "nxt"
        ],
        "gender": "FEMALE",
        "points": 75
    },
    {
        "id": "kiana-james",
        "name": "Kiana James",
        "brandIds": [
            "raw"
        ],
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/04/Kianna_James_PROFILE--2d9b5211256605f1a79e3093deb77974.png",
        "gender": "FEMALE",
        "points": 75
    },
    {
        "id": "roxanne-perez",
        "name": "Roxanne Perez",
        "image": "//www.wwe.com/f/styles/talent_champion_xs/public/all/2023/06/ROXANNE_PEREZ_04012023sb0169_profile--966f8699bbb407611ec70e706669d312.png",
        "brandIds": [
            "nxt"
        ],
        "alignment": "GOOD",
        "points": 78,
        "gender": "FEMALE"
    },
    {
        "id": "alex-shelley",
        "name": "Alex Shelley",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "bully-ray",
        "name": "Bully Ray",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "ace-austin",
        "name": "Ace Austin",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "brian-myers",
        "name": "Brian Myers",
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/MyersNew.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "chris-sabin",
        "name": "Chris Sabin",
        "points": 75,
        "cost": 55000,
        "alignment": "GOOD",
        "brandIds": [
            "tna"
        ],
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/ChrisSabin_2024.jpg",
        "followers": 5000
    },
    {
        "id": "crazzy-steve",
        "name": "Crazzy Steve",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "eddie-edwards",
        "name": "Eddie Edwards",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "eric-young",
        "name": "Eric Young",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "gail-kim",
        "name": "Gail Kim",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "gia-miller",
        "name": "Gia Miller",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "heath",
        "name": "Heath",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "jonathan-gresham",
        "name": "Jonathan Gresham",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "joydnne-grace",
        "name": "Joydnne Grace",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "josh-alexander",
        "name": "Josh Alexander",
        "image": "//tnawrestling.com/wp-content/uploads/2020/09/JoshAlexander_2023.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "kon",
        "name": "Kon",
        "image": "//tnawrestling.com/wp-content/uploads/2022/11/Kon_2022.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "kushida",
        "name": "Kushida",
        "image": "//tnawrestling.com/wp-content/uploads/2022/07/KUSHIDA_2022_1.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "oleg-prudius",
        "name": "Oleg Prudius",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "pco",
        "name": "PCO",
        "image": "//tnawrestling.com/wp-content/uploads/2022/06/PCO_2023.jpg",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "rhino",
        "name": "Rhino",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "santino-marella",
        "name": "Santino Marella",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "rich-swann",
        "name": "Rich Swann",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "steve-maclin",
        "name": "Steve Maclin",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "su-yung",
        "name": "Su Yung",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "trent-seven",
        "name": "Trent Seven",
        "points": 75,
        "cost": 55000,
        "alignment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    },
    {
        "id": "xia-brookside",
        "name": "Xia Brookside",
        "points": 75,
        "cost": 55000,
        "aligment": "NEUTRAL",
        "brandIds": [
            "tna"
        ],
        "followers": 5000
    }
];
const _default = collection;
